<template>
  <div ref="container">
    <v-dialog
      v-model="dialogs.activateWarning"
      scrollable
      persistent
      max-width="400"
    >
      <material-card
      :title="$t('views.plans.activate')"
        :color="$vuetify.theme.themes.light.success"
        icon="publish"
      >
        <v-card-text>
          {{ $t("views.planwizardview.activate_warning_message") }}
        </v-card-text>
        <v-card-actions>
          <v-btn color text @click="dialogs.activateWarning = false">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn color="success" text @click="finalizeDraft">
            {{ $t("views.plans.activate") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog
      v-model="dialogs.sickDayWarning"
      scrollable
      persistent
      max-width="400"
    >
      <material-card
        :title="$t('globals.warning')"
        :color="$vuetify.theme.themes.light.warning"
        icon="science"
      >
        <v-card-text>
          {{ $t("views.planwizardview.sick_day_warning_message") }}
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" text @click="closeSickDayWarning">
            {{ $t("globals.ok") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog
      v-model="dialogs.draftWarning"
      scrollable
      persistent
      max-width="400"
    >
      <material-card
      :title="$t('globals.warning')"
        :color="$vuetify.theme.themes.light.warning"
        icon="science"
      >
        <v-card-text>
          {{ $t("views.planwizardview.test_warning_message") }}
        </v-card-text>
        <v-card-actions>
          <v-btn
            :loading="saving"
            color
            text
            @click="dialogs.draftWarning = false"
          >
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn :loading="saving" color="primary" text @click="testDraft">
            {{ $t("views.plans.go_to_test_mode") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog scrollable v-model="loadingPlan" persistent max-width="200">
      <v-card>
        <v-card-title>{{ $t("globals.please_wait") }}</v-card-title>
        <v-card-text>
          <v-container fluid grid-list-md>
            <v-layout row justify-center>
              <v-flex xs12 sm6 md4 lg3>
                <v-progress-circular indeterminate></v-progress-circular>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogs.warning" persistent max-width="500">
      <v-card>
        <v-card-title class="headline">
          {{ $t("views.planwizardview.warning_exit_without_save") }}
        </v-card-title>
        <v-card-text>
          {{ $t("views.planwizardview.warning_exit_without_save_confirm") }}
        </v-card-text>
        <v-card-actions>
          <v-btn
            text
            @click="
              dialogs.warning = false;
              dialogs.warningResult = false;
            "
          >
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn
            color="primary"
            @click="
              dialogs.warning = false;
              dialogs.warningResult = true;
            "
          >
            {{ $t("views.planwizardview.remove_draft") }}
          </v-btn>
          <v-btn
            color="primary"
            @click="
              save();
              dialogs.warning = false;
              dialogs.warningResult = true;
            "
          >
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div
      v-show="isFixedActionsBarVisible"
      :style="{
        position: 'fixed',
        top: '0',
        background: 'white',
        width: '100%',
        'overflow-x': 'auto',
        'z-index': 2,
      }"
    >
      <v-card-actions>
        <v-btn color text @click="close">
          {{ $t("globals.close") }}
        </v-btn>
        <v-btn :disabled="!isChanged" color="primary" text @click="save">
          {{ $t("globals.save") }}
        </v-btn>
        <v-btn :disabled="isChanged" color="primary" text @click="tryValidate">
          {{ $t("globals.validate") }}
        </v-btn>
        <v-btn
          :disabled="!validated || isChanged || !isValid || !builderValid"
          color="primary"
          text
          @click="
            exitWithoutWarning = true;
            dialogs.draftWarning = true;
          "
        >
          {{ $t("views.plans.test") }}
        </v-btn>
        <!-- <v-btn
          :disabled="!validated || isChanged || !isValid || !valid"
          color="primary"
          text
          @click="
            exitWithoutWarning = true;
            dialogs.activateWarning = true;
          "
        >
          {{ $t("views.planwizardview.activate") }}
        </v-btn> -->
      </v-card-actions>
    </div>
    <material-card
      v-if="selectedItem !== null && selectedItem !== undefined"
      :title="materialTitle"
      :color="$vuetify.theme.themes.light.secondary"
      icon="note_add"
      id="plan_builder_view_material_card"
    >
      <v-card-actions id="top-actions" v-show="!isFixedActionsBarVisible">
        <v-btn color text @click="close">
          {{ $t("globals.close") }}
        </v-btn>
        <v-btn :disabled="!isChanged" color="primary" text @click="save">
          {{ $t("globals.save") }}
        </v-btn>
        <v-btn :disabled="isChanged" color="primary" text @click="tryValidate">
          {{ $t("globals.validate") }}
        </v-btn>
        <v-btn
          :disabled="!validated || isChanged || !isValid || !builderValid"
          color="primary"
          text
          @click="
            exitWithoutWarning = true;
            dialogs.draftWarning = true;
          "
        >
          {{ $t("views.plans.test") }}
        </v-btn>
        <!-- <v-btn
          :disabled="!validated || isChanged || !isValid || !valid"
          color="primary"
          text
          @click="
            exitWithoutWarning = true;
            dialogs.activateWarning = true;
          "
        >
          {{ $t("views.planwizardview.activate") }}
        </v-btn> -->
      </v-card-actions>
      <v-card-text>
        <plan-builder
          v-if="planType === 'HW'"
          :validated="validated"
          :validationErrors="validationErrors"
          :panelsWithErrors="panelsWithErrors"
          ref="creationWizard"
          @valid-changed="validChanged"
          :planId="planIdentityId"
          :generalSettings="selectedItem.GeneralSettings"
          @change-insurance-carriers="changeInsuranceCarriers"
          :planInsuranceCarriers="selectedItem.PlanInsuranceCarriers"
          :trustFund="selectedItem.TrustFund"
          @trust-fund="changeTrustFund"
          :bankAccount="selectedItem.TrustFund.BankAccount"
          @bank-account="selectedItem.TrustFund.BankAccount = $event"
          :employers="selectedItem.Employers"
          @change-employers="changeEmployers"
          :flags="selectedItem.Flags"
          @change-flags="selectedItem.Flags = $event"
          :selectedFields="selectedItem.MemberDataFields"
          @change-fields="changeMemberFields"
          :internalContacts="selectedItem.Contacts"
          @change-contacts="
            selectedItem.Contacts = $event;
            isChanged = true;
          "
          change-billing-fields:coverage="selectedItem.Coverages"
          :coverage="selectedItem.Coverages"
          @change-coverage="changeCoverage"
          :coverageParameters="selectedItem.ConfigurationParameters"
          @change-coverage-parameters="changeCoverageParameters"
          :formulas="selectedItem.CalculationFormulas"
          @change-formulas="selectedItem.CalculationFormulas = $event"
          :memberGroups="selectedItem.MemberGroups"
          @change-groups="changeMemberGroups"
          :eligibilityHourBankSettings="selectedItem.EligibilityHourBankSettings"
          @change-eligibility-hour-bank-settings="changeEligibilityHourBankSettings"
          :selfPaymentSettings="selectedItem.SelfPaymentSettings"
          @change-self-payment-settings="changeSelfPaymentSettings"
          :reportConfiguration="selectedItem.ReportConfiguration"
          @change-report="selectedItem.ReportConfiguration = $event"
          :demographicsFields="selectedItem.DemographicFields"
          @change-demographics="selectedItem.DemographicFields = $event"
          :planParameters="planParameters"
          :eligibility="selectedItem.Eligibility"
          @change-eligibility="selectedItem.Eligibility = $event"
          :savedEligibility="savedEligibility"
          :billingFields="selectedItem.BillingImportFields"
          @change-billing-fields="selectedItem.BillingImportFields = $event"
          :billingTerm="selectedItem.BillingTerm"
          @change-billing-term="
            selectedItem.BillingTerm = $event;
            isChanged = true;
          "
          :contributionCategories="selectedItem.ContributionCategories"
          @change-contribution-categories="
            selectedItem.ContributionCategories = $event;
            isChanged = true;
          "
          :hasClasses="hasClasses"
          @has-classes="
            hasClasses = $event;
            fixMemberFields();
            isChanged = true;
          "
          :hasOccupations="hasOccupations"
          @has-occupations="
            hasOccupations = $event;
            fixMemberFields();
            isChanged = true;
          "
          @update-classes="
            classesStr = $event;
            isChanged = true;
          "
          @update-occupations="
            occupationsStr = $event;
            isChanged = true;
          "
          @classes-array="classesArray = $event"
          :classesArray="classesArray"
          @activity-status-rules="
            selectedItem.Eligibility.ActivityStatusRules = $event;
            isChanged = true;
          "
          @benefit-rules="
            selectedItem.Eligibility.BenefitRules = $event;
            isChanged = true;
          "
          @eligibility-period-rules="
            selectedItem.Eligibility.EligibilityPeriodRules = $event;
            isChanged = true;
          "
          @plan-coverage-commencement-rules="
            selectedItem.Eligibility.CoverageCommencementRules = $event;
            isChanged = true;
          "
          @member-coverage-eligibility-rules="
            selectedItem.Eligibility.MemberCoverageEligibilityRules = $event;
            isChanged = true;
          "
          :reportConfigurationAddress="reportConfigurationAddress"
          @report-configuration-address="reportConfigurationAddress = $event"
          :defaultDataGrouping="defaultDataGrouping"
          @default-data-grouping="
            defaultDataGrouping = $event;
            isChanged = true;
          "
          :additionalDataGrouping="additionalDataGrouping"
          @additional-data-grouping="
            additionalDataGrouping = $event;
            isChanged = true;
          "
          :coverageGroups="coverageGroups"
          @coverage-groups="
            coverageGroups = $event;
            isChanged = true;
          "
          :primaryIdentifier="
            selectedItem.HoursSetup.PrimaryHourImportMemberIdentifier
          "
          :candidateIdentifiers="
            selectedItem.HoursSetup.CandidateHourImportMemberIdentifiers
          "
          :includeContributionAmount="
            selectedItem.HoursSetup.IncludeContributionAmount
          "
          @update-primary-identifier="
            selectedItem.HoursSetup.PrimaryHourImportMemberIdentifier = $event;
            isChanged = true;
          "
          @update-candidate-identifiers="
            selectedItem.HoursSetup.CandidateHourImportMemberIdentifiers =
              $event;
            isChanged = true;
          "
          @update-include-contribution-amount="
            selectedItem.HoursSetup.IncludeContributionAmount = $event;
            isChanged = true;
          "
          :logicalExpressionsHeaders="logicalExpressionsHeaders"
          :logicalExpressionsFields="logicalExpressionsFields"
          @get-logical-expressions-headers="loadLogicalExpressionsFields"
          :memberLogicalExpressionsHeaders="memberLogicalExpressionsHeaders"
          :memberLogicalExpressionsFields="memberLogicalExpressionsFields"
          @get-member-logical-expressions-headers="
            loadMemberLogicalExpressionsFields
          "
          :planType="planType"
          :calculationEntitiesFormulaTypes="calculationEntitiesFormulaTypes"
          :planVariables="planVariables"
          :taxParameters="taxParameters"
          :memberFields="memberFields"
          :allDemographicsFields="allDemographicsFields"
          :allBillingImportFields="allBillingImportFields"
          :insuranceCarriers="insuranceCarriers"
          :uniqueIdentifiers="uniqueIdentifiers"
          @load-unique-identifiers="loadUniqueIdentifiers"
          :brokers="brokers"
          :claimParameters="claimParameters"
        />
        <pensions-plan-builder
          v-else-if="planType === 'Pension'"
          :validated="validated"
          :validationErrors="validationErrors"
          :panelsWithErrors="panelsWithErrors"
          ref="creationWizard"
          @valid-changed="validChanged"
          :planId="planIdentityId"
          :generalSettings="selectedItem.GeneralSettings"
          @loaded="loadingPlan = false"
          :planType="planType"
          :unions="selectedItem.Unions"
          @unions-changed="
            selectedItem.Unions = $event;
            isChanged = true;
          "
          :employers="selectedItem.Employers"
          @change-employers="changeEmployers"
          :trustFund="selectedItem.TrustFund"
          @trust-fund="changeTrustFund"
          :selectedFields="selectedItem.MemberDataFields"
          @change-fields="changeMemberFields"
          :bankAccount="selectedItem.TrustFund.BankAccount"
          @bank-account="
            selectedItem.TrustFund.BankAccount = $event;
            isChanged = true;
          "
          :brokerId="organization.Id"
          :draftId="draftId"
          @change-coverage="changeCoverage"
          :coverage="selectedItem.Coverages"
          :memberGroups="selectedItem.MemberGroups"
          @change-groups="changeMemberGroups"
          :flags="selectedItem.Flags"
          @change-flags="selectedItem.Flags = $event"
          :hasClasses="hasClasses"
          @has-classes="
            hasClasses = $event;
            fixMemberFields();
            isChanged = true;
          "
          :hasOccupations="hasOccupations"
          @has-occupations="
            hasOccupations = $event;
            fixMemberFields();
            isChanged = true;
          "
          @update-classes="
            classesStr = $event;
            isChanged = true;
          "
          @update-occupations="
            occupationsStr = $event;
            isChanged = true;
          "
          @classes-array="classesArray = $event"
          :classesArray="classesArray"
          :billingFields="selectedItem.BillingImportFields"
          @change-billing-fields="selectedItem.BillingImportFields = $event"
          :billingTerm="selectedItem.BillingTerm"
          @change-billing-term="
            selectedItem.BillingTerm = $event;
            isChanged = true;
          "
          :contributionCategories="selectedItem.ContributionCategories"
          @change-contribution-categories="
            selectedItem.ContributionCategories = $event;
            isChanged = true;
          "
          @update-primary-identifier="
            selectedItem.HoursSetup.PrimaryHourImportMemberIdentifier = $event;
            isChanged = true;
          "
          @update-candidate-identifiers="
            selectedItem.HoursSetup.CandidateHourImportMemberIdentifiers =
              $event;
            isChanged = true;
          "
          :primaryIdentifier="
            selectedItem.HoursSetup.PrimaryHourImportMemberIdentifier
          "
          :candidateIdentifiers="
            selectedItem.HoursSetup.CandidateHourImportMemberIdentifiers
          "
          :includeContributionAmount="
            selectedItem.HoursSetup.IncludeContributionAmount
          "
          @update-include-contribution-amount="
            selectedItem.HoursSetup.IncludeContributionAmount = $event;
            isChanged = true;
          "
          :coverageParameters="selectedItem.ConfigurationParameters"
          @change-coverage-parameters="changeCoverageParameters"
          :calculationEntitiesFormulaTypes="calculationEntitiesFormulaTypes"
          :planVariables="planVariables"
          :taxParameters="taxParameters"
          :memberFields="memberFields"
          :uniqueIdentifiers="uniqueIdentifiers"
          :allBillingImportFields="allBillingImportFields"
          :claimParameters="claimParameters"
        />
        <no-managed-plan-builder
          v-else
          :validated="validated"
          :validationErrors="validationErrors"
          :panelsWithErrors="panelsWithErrors"
          ref="creationWizard"
          @valid-changed="validChanged"
          :planId="planIdentityId"
          :generalSettings="selectedItem.GeneralSettings"
          @loaded="loadingPlan = false"
          :planType="planType"
          :unions="selectedItem.Unions"
          @unions-changed="
            selectedItem.Unions = $event;
            isChanged = true;
          "
          :employers="selectedItem.Employers"
          @change-employers="changeEmployers"
          :trustFund="selectedItem.TrustFund"
          @trust-fund="changeTrustFund"
          :selectedFields="selectedItem.MemberDataFields"
          @change-fields="changeMemberFields"
          :bankAccount="selectedItem.TrustFund.BankAccount"
          @bank-account="
            selectedItem.TrustFund.BankAccount = $event;
            isChanged = true;
          "
          :brokerId="organization.Id"
          :draftId="draftId"
          @change-coverage="changeCoverage"
          :coverage="selectedItem.Coverages"
          :memberGroups="selectedItem.MemberGroups"
          @change-groups="changeMemberGroups"
          :flags="selectedItem.Flags"
          @change-flags="selectedItem.Flags = $event"
          :hasClasses="hasClasses"
          @has-classes="
            hasClasses = $event;
            fixMemberFields();
            isChanged = true;
          "
          :hasOccupations="hasOccupations"
          @has-occupations="
            hasOccupations = $event;
            fixMemberFields();
            isChanged = true;
          "
          @update-classes="
            classesStr = $event;
            isChanged = true;
          "
          @update-occupations="
            occupationsStr = $event;
            isChanged = true;
          "
          @classes-array="classesArray = $event"
          :classesArray="classesArray"
          :billingFields="selectedItem.BillingImportFields"
          @change-billing-fields="selectedItem.BillingImportFields = $event"
          :billingTerm="selectedItem.BillingTerm"
          @change-billing-term="
            selectedItem.BillingTerm = $event;
            isChanged = true;
          "
          :contributionCategories="selectedItem.ContributionCategories"
          @change-contribution-categories="
            selectedItem.ContributionCategories = $event;
            isChanged = true;
          "
          @update-primary-identifier="
            selectedItem.HoursSetup.PrimaryHourImportMemberIdentifier = $event;
            isChanged = true;
          "
          @update-candidate-identifiers="
            selectedItem.HoursSetup.CandidateHourImportMemberIdentifiers =
              $event;
            isChanged = true;
          "
          :primaryIdentifier="
            selectedItem.HoursSetup.PrimaryHourImportMemberIdentifier
          "
          :candidateIdentifiers="
            selectedItem.HoursSetup.CandidateHourImportMemberIdentifiers
          "
          :includeContributionAmount="
            selectedItem.HoursSetup.IncludeContributionAmount
          "
          @update-include-contribution-amount="
            selectedItem.HoursSetup.IncludeContributionAmount = $event;
            isChanged = true;
          "
          :coverageParameters="selectedItem.ConfigurationParameters"
          @change-coverage-parameters="changeCoverageParameters"
          :calculationEntitiesFormulaTypes="calculationEntitiesFormulaTypes"
          :planVariables="planVariables"
          :taxParameters="taxParameters"
          :memberFields="memberFields"
          :uniqueIdentifiers="uniqueIdentifiers"
          :allBillingImportFields="allBillingImportFields"
          :claimParameters="claimParameters"
        />
      </v-card-text>
      <v-card-actions id="bottom-actions">
        <v-btn color text @click="close">
          {{ $t("globals.close") }}
        </v-btn>
        <v-btn :disabled="!isChanged" color="primary" text @click="save">
          {{ $t("globals.save") }}
        </v-btn>
        <v-btn :disabled="isChanged" color="primary" text @click="tryValidate">
          {{ $t("globals.validate") }}
        </v-btn>
        <v-btn
          :disabled="!validated || isChanged || !isValid || !builderValid"
          color="primary"
          text
          @click="
            exitWithoutWarning = true;
            dialogs.draftWarning = true;
          "
        >
          {{ $t("views.plans.test") }}
        </v-btn>
        <!-- <v-btn
          :disabled="!validated || isChanged || !isValid || !valid"
          color="primary"
          text
          @click="
            exitWithoutWarning = true;
            dialogs.activateWarning = true;
          "
        >
          {{ $t("views.planwizardview.activate") }}
        </v-btn> -->
      </v-card-actions>
    </material-card>
    <v-snackbar
      v-model="snackbar"
      :color="color"
      :multi-line="mode === 'multi-line'"
      :timeout="timeout"
      :vertical="mode === 'vertical'"
    >
      {{ message }}
      <v-btn dark text @click="snackbar = false">
        {{ $t("globals.close") }}
      </v-btn>
    </v-snackbar>
    <error-handler :error="error"></error-handler>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import PlanBuilder from "../components/PlanBuilder/PlanBuilder.vue";
import ErrorHandler from "../components/ErrorHandler";
import { locker } from "../mixins/locker";
import { translate2 } from "../trans2";
import { tokens } from "vue-the-mask";
import masker from "vue-the-mask/src/masker";
import {
  LogicalExpressionsHeader,
  LogicalExpressionsString,
  LogicalExpressionsBoolean,
  LogicalExpressionsNumber,
  LogicalExpressionsEnum,
  LogicalExpressionsDate,
} from "pbas-vue-components";
import PensionsPlanBuilder from "@/components/PlanBuilder/PensionsPlanBuilder.vue";
import NoManagedPlanBuilder from "@/components/PlanBuilder/NoManagedPlanBuilder.vue";
export default {
  name: "plan-wizard-view",
  components: {
    ErrorHandler,
    PlanBuilder,
    PensionsPlanBuilder,
    NoManagedPlanBuilder,
  },
  mixins: [locker],
  data() {
    return {
      draftId: null,
      builderValid: false,
      isValid: false,
      isChanged: false,
      planParameters: [], //TODO, use this for non coverage formulas validation
      status: null,
      routeData: null,
      exitWithoutWarning: false,
      organization: null,
      planIdentityId: null,
      dialogs: {
        warning: false,
        warningResult: false,
        draftWarning: false,
        activateWarning: false,
        sickDayWarning: false
      },
      loadingPlan: false,
      error: null,
      selectedItem: null,
      snackbar: false,
      color: "",
      mode: "",
      timeout: 2500,
      message: "",
      savedEligibility: false,
      timeoutResult: null,
      isFixedActionsBarVisible: false,
      hasClasses: false,
      hasOccupations: false,
      classesStr: null,
      occupationsStr: null,
      classesArray: [],
      reportConfigurationAddress: {
        Address: {},
      },
      defaultDataGrouping: null,
      coverageGroups: [],
      validationErrors: [],
      panelsWithErrors: [],
      saving: false,
      additionalDataGrouping: null,
      validated: false,
      logicalExpressionsHeaders: [],
      logicalExpressionsFields: [],
      memberLogicalExpressionsHeaders: [],
      memberLogicalExpressionsFields: [],
      planType: null,
      telephoneMask: "(###) ### - ####",
      calculationEntitiesFormulaTypes: [],
      planVariables: [],
      taxParameters: [],
      memberFields: [],
      allMemberFields: [],
      allDemographicsFields: [],
      allBillingImportFields: [],
      insuranceCarriers: [],
      uniqueIdentifiers: [],
      brokers: [],
      claimParameters: [],
    };
  },
  computed: {
    ...mapGetters("common", ["language"]),
    ...mapGetters("plansMembers", ["options"]),
    materialTitle() {
      let names = [];
      if (
        this.selectedItem.GeneralSettings.UniqueIdentifier !== null &&
        this.selectedItem.GeneralSettings.UniqueIdentifier !== undefined
      ) {
        names.push(this.selectedItem.GeneralSettings.UniqueIdentifier);
      }
      if (
        this.selectedItem.GeneralSettings.PlanSettings !== null &&
        this.selectedItem.GeneralSettings.PlanSettings !== undefined &&
        this.selectedItem.GeneralSettings.PlanSettings.Name !== null &&
        this.selectedItem.GeneralSettings.PlanSettings.Name !== undefined
      ) {
        names.push(
          translate2(this.selectedItem.GeneralSettings.PlanSettings, "Name")
        );
      }
      if (names.length > 0) {
        return names.join(" - ");
      }
      return this.$t("components.plancreationwizard.plan_creation_wizard");
    },
    activeStatus() {
      return this.options.Models.Status.filter((o) => o.Name === "Active")[0]
        .Id;
    },
    activeParticipationStatus() {
      return this.options.Models.ParticipationStatus.filter(
        (o) => o.Name === "Active"
      )[0].Id;
    },
  },
  watch: {
    "dialogs.warningResult": {
      async handler(v) {
        if (v) {
          this.routeData.next();
        } else {
          if (this.routeData && this.routeData.next) {
            this.routeData.next(false);
          }
        }
      },
    },
    options: {
      handler(v) {
        if (v !== null && v !== undefined) {
          this.init();
        }
      },
    },
    selectedItem: {
      handler(v) {
        if (this.loadingPlan || v === null || v === undefined) {
          this.isChanged = false;
          return;
        }
        this.isChanged = true;
      },
      immediate: true,
      deep: true,
    },
    "selectedItem.GeneralSettings.PlanSettings.HasAdminFees": {
      handler(v) {
        if (!v) {
          this.uncheckCoverageAdminCheckboxes();
          // this.deleteAdminFeesFormulas();
        }
      },
    },
    "selectedItem.GeneralSettings.PlanSettings.AdminFeesPerTerm": {
      handler(v, old) {
        console.log("watch AdminFeesPerTerm: ", v);
        if (!v) {
          // this.uncheckCoverageAdminCheckboxes();
          this.deleteAdminFeesFormulas();
        }
      },
    },
    "selectedItem.GeneralSettings.PlanSettings.HasPlanFlatAdminFees": {
      handler(v) {
        console.log("watch HasPlanFlatAdminFees: ", v);
        if (!v) {
          this.deletePlanFlatAdminFeesFormulas();
        }
      },
    },
    "selectedItem.GeneralSettings.PlanSettings.HasPlanClaimAdminFees": {
      handler(v) {
        console.log("watch HasPlanClaimAdminFees: ", v);
        if (!v) {
          this.deletePlanClaimAdminFeesFormulas();
        }
      },
    },
    "selectedItem.GeneralSettings.PlanSettings.HasOperatingFees": {
      handler(v) {
        if (!v) {
          this.selectedItem.GeneralSettings.PlanSettings.OperatingFeesPerTerm = false;
          this.uncheckCoverageOperatingCheckboxes();
          this.deleteOperatingFeesFormulas();
        }
      },
    },
    "selectedItem.GeneralSettings.PlanSettings.OperatingFeesPerTerm": {
      handler(v, old) {
        if (old === false && v) {
          this.uncheckCoverageOperatingCheckboxes();
          this.deleteOperatingFeesFormulas();
        }
      },
    },
    "selectedItem.GeneralSettings.PlanSettings.HasPremiums": {
      handler(v) {
        if (!v) {
          this.selectedItem.PlanInsuranceCarriers = [];
        }
      },
    },
    "selectedItem.GeneralSettings.PlanSettings.IncludeTrustFund": {
      handler(v) {
        if (v) {
          if (
            this.selectedItem.TrustFund === null ||
            this.selectedItem.TrustFund === undefined
          ) {
            this.selectedItem.TrustFund = { Contacts: [], BankAccount: {} };
          }
        } else {
          this.selectedItem.TrustFund = { Contacts: [], BankAccount: {} };
        }
      },
    },
    "selectedItem.GeneralSettings.TrackHours": {
      handler(v) {
        if (!v && this.planType === "HW") {
          delete this.selectedItem.HoursSetup.PrimaryHourImportMemberIdentifier;
          this.selectedItem.HoursSetup.CandidateHourImportMemberIdentifiers =
            [];
          delete this.selectedItem.HoursSetup.IncludeContributionAmount;
        }
      },
    },
    "selectedItem.GeneralSettings.PlanSettings.HasBilling": {
      handler(v) {
        if (!v) {
          this.selectedItem.BillingImportFields = [];
          delete this.selectedItem.BillingTerm;
          this.selectedItem.ContributionCategories = [];
        } else {
          if (this.selectedItem.BillingTerm === null || this.selectedItem.BillingTerm === undefined) {
            this.selectedItem.BillingTerm = [];
          }
        }
      },
    },
    "selectedItem.GeneralSettings.HasEligibility": {
      handler(v) {
        // if (!v) {
        //   this.selectedItem.Eligibility = undefined;
        // } else 
        if (
          v &&
          (this.selectedItem.Eligibility === null ||
            this.selectedItem.Eligibility === undefined)
        ) {
          this.selectedItem.Eligibility = {
            ActivityStatusRules: [],
            BenefitRules: [],
            EligibilityPeriodRules: [],
            CoverageCommencementRules: [],
            MemberCoverageEligibilityRules: [],
            MemberEligibility: {},
          };
        }
      },
    },
    // "selectedItem.GeneralSettings.HasEligibilityBank": {
    //   handler(v) {
    //     if (!v) {
    //       this.selectedItem.Eligibility = undefined;
    //     } else if (
    //       v &&
    //       (this.selectedItem.Eligibility === null ||
    //         this.selectedItem.Eligibility === undefined)
    //     ) {
    //       this.selectedItem.Eligibility = {
    //         ActivityStatusRules: [],
    //         BenefitRules: [],
    //         EligibilityPeriodRules: [],
    //         CoverageCommencementRules: [],
    //         MemberCoverageEligibilityRules: [],
    //         MemberEligibility: {},
    //       };
    //     }
    //   },
    // },
    "selectedItem.GeneralSettings.PlanSettings.HasDemographics": {
      handler(v) {
        if (!v) {
          this.selectedItem.DemographicFields = [];
        }
      },
    },
    // "selectedItem.TrustFund": {
    //   handler(v) {
    //     console.log("watch trustfund: ", JSON.stringify(v));
    //   },
    //   deep: true,
    //   immediate: true,
    // },
  },
  // updated() {
  //   if (
  //     this.$el !== undefined &&
  //     this.$el !== null &&
  //     this.$el.querySelector !== undefined
  //   ) {
  //     this.onScroll();
  //   }
  // },
  mounted() {
    if (this.options !== null && this.options !== undefined) {
      this.init();
    }
    // window.addEventListener("resize", this.onWindowSizeChanged);
    window.addEventListener("scroll", this.onScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    ...mapActions("plansMembers", [
      "getPlanById",
      "getOrganizationById",
      "getPlanConfigurationParameters",
      "activatePlan",
      "testPlan",
      "saveDraft",
      "validateDraft",
      "getLogicalExpressionsFields",
      "getMemberLogicalExpressionsFields",
      "getCalculationEntitiesFormulaTypes",
      "getPlanVariablesBuilder",
      "getAllTaxParameters",
      "getMemberFields",
      "getDemographicsFields",
      "getBillingImportFields",
      "getAllInsuranceCarriers",
      "getPlanUniqueIdentifiersById",
      "getOrganizationBrokers",
      "getClaimParameters",
    ]),
    uncheckCoverageAdminCheckboxes() {
      console.log("uncheck coverage admin checkboxes");
      for (let coverage of this.selectedItem.Coverages) {
        coverage.HasAdminFees = false;
        coverage.IncludeAdminPPT = false;
        coverage.IncludeAdminRST = false;
        coverage.IncludeAdminHST = false;
        coverage.IncludeAdminGST = false;
        coverage.IncludeAdminPST = false;
      }
    },
    uncheckCoverageOperatingCheckboxes() {
      console.log("uncheck coverage operating checkboxes");
      for (let coverage of this.selectedItem.Coverages) {
        coverage.HasOperatingFees = false;
        coverage.IncludeOperatingPPT = false;
        coverage.IncludeOperatingRST = false;
        coverage.IncludeOperatingHST = false;
        coverage.IncludeOperatingGST = false;
        coverage.IncludeOperatingPST = false;
      }
    },
    deleteAdminFeesFormulas() {
      console.log("delete admin fees formulas");
      this.selectedItem.CalculationFormulas =
        this.selectedItem.CalculationFormulas.filter(
          (o) =>
            (o.SystemName !== "AdminFee" ||
              (o.SystemName === "AdminFee" &&
                o.CoverageIdentity !== null &&
                o.CoverageIdentity !== undefined &&
                o.CoverageIdentityId !== o.PlanIdentityId)) &&
            (o.SystemName !== "PPTAdminTax" ||
              (o.SystemName === "PPTAdminTax" &&
                o.CoverageIdentity !== null &&
                o.CoverageIdentity !== undefined &&
                o.CoverageIdentityId !== o.PlanIdentityId)) &&
            (o.SystemName !== "RSTAdminTax" ||
              (o.SystemName === "RSTAdminTax" &&
                o.CoverageIdentity !== null &&
                o.CoverageIdentity !== undefined &&
                o.CoverageIdentityId !== o.PlanIdentityId)) &&
            (o.SystemName !== "HSTAdminTax" ||
              (o.SystemName === "HSTAdminTax" &&
                o.CoverageIdentity !== null &&
                o.CoverageIdentity !== undefined &&
                o.CoverageIdentityId !== o.PlanIdentityId)) &&
            (o.SystemName !== "PSTAdminTax" ||
              (o.SystemName === "PSTAdminTax" &&
                o.CoverageIdentity !== null &&
                o.CoverageIdentity !== undefined &&
                o.CoverageIdentityId !== o.PlanIdentityId)) &&
            (o.SystemName !== "GSTAdminTax" ||
              (o.SystemName === "GSTAdminTax" &&
                o.CoverageIdentity !== null &&
                o.CoverageIdentity !== undefined &&
                o.CoverageIdentityId !== o.PlanIdentityId))
        );
    },
    deletePlanFlatAdminFeesFormulas() {
      console.log("delete admin fees formulas");
      this.selectedItem.CalculationFormulas =
        this.selectedItem.CalculationFormulas.filter(
          (o) =>
            o.SystemName !== "PlanFlatAdminFee" &&
            o.SystemName !== "PlanFlatPPTAdminTax" &&
            o.SystemName !== "PlanFlatRSTAdminTax" &&
            o.SystemName !== "PlanFlatHSTAdminTax" &&
            o.SystemName !== "PlanFlatPSTAdminTax" &&
            o.SystemName !== "PlanFlatGSTAdminTax"
        );
    },
    deletePlanClaimAdminFeesFormulas() {
      console.log("delete admin fees formulas");
      this.selectedItem.CalculationFormulas =
        this.selectedItem.CalculationFormulas.filter(
          (o) =>
            o.SystemName !== "PlanClaimAdminFee" &&
            o.SystemName !== "PlanClaimPPTAdminTax" &&
            o.SystemName !== "PlanClaimRSTAdminTax" &&
            o.SystemName !== "PlanClaimHSTAdminTax" &&
            o.SystemName !== "PlanClaimPSTAdminTax" &&
            o.SystemName !== "PlanClaimGSTAdminTax"
        );
    },
    deleteOperatingFeesFormulas() {
      console.log("delete operating fees formulas");
      this.selectedItem.CalculationFormulas =
        this.selectedItem.CalculationFormulas.filter(
          (o) =>
            o.SystemName !== "OperatingFee" &&
            o.SystemName !== "PPTOperatingTax" &&
            o.SystemName !== "RSTOperatingTax" &&
            o.SystemName !== "HSTOperatingTax" &&
            o.SystemName !== "PSTOperatingTax" &&
            o.SystemName !== "GSTOperatingTax"
        );
    },
    async loadMemberLogicalExpressionsFields() {
      const payload = this.fixPayloadForPost();
      try {
        let logicalExpressionsFields = (
          await this.getMemberLogicalExpressionsFields({
            planIdentityId: this.planIdentityId,
            payload: {
              GeneralSettings: payload.GeneralSettings,
              MemberDataFields: payload.MemberDataFields,
            },
          })
        ).data;
        logicalExpressionsFields.push({
          Name: "DateOfBirth",
          Label: "Date Of Birth",
          Type: "Date",
        });
        this.memberLogicalExpressionsFields = logicalExpressionsFields;
        this.memberLogicalExpressionsHeaders =
          this.createLogicalExpressionsHeaders(logicalExpressionsFields);
      } catch (error) {
        this.error = error;
      }
    },
    async loadLogicalExpressionsFields() {
      const payload = this.fixPayloadForPost();
      try {
        let logicalExpressionsFields = (
          await this.getLogicalExpressionsFields({
            planIdentityId: this.planIdentityId,
            payload: {
              GeneralSettings: payload.GeneralSettings,
              MemberDataFields: payload.MemberDataFields,
            },
          })
        ).data;

        this.logicalExpressionsFields = logicalExpressionsFields;
        this.logicalExpressionsHeaders = this.createLogicalExpressionsHeaders(
          logicalExpressionsFields
        );
      } catch (error) {
        this.error = error;
      }
    },
    createLogicalExpressionsHeaders(fields) {
      console.log(fields);
      let logicalExpressionsHeaders = [];
      for (const field of fields) {
        let header;
        switch (field.Type) {
          case "String": {
            header = new LogicalExpressionsHeader({
              title: field.Label,
              type: new LogicalExpressionsString(field.Name),
            });
            break;
          }
          case "Number": {
            header = new LogicalExpressionsHeader({
              title: field.Label,
              type: new LogicalExpressionsNumber(field.Name),
            });
            break;
          }
          case "Boolean": {
            header = new LogicalExpressionsHeader({
              title: field.Label,
              type: new LogicalExpressionsBoolean(field.Name),
            });
            break;
          }
          case "Enum": {
            let parts = field.EnumName.split(".");
            header = new LogicalExpressionsHeader({
              title: field.Label,
              type: new LogicalExpressionsEnum(field.Name, {
                dropdownItems: this.options[parts[0]][parts[1]],
                language: this.language.language,
              }),
            });
            break;
          }
          case "Date": {
            header = new LogicalExpressionsHeader({
              title: field.Label,
              type: new LogicalExpressionsDate(field.Name),
            });
            break;
          }
          default: {
            break;
          }
        }
        if (header) {
          logicalExpressionsHeaders.push(header);
        }
      }
      return logicalExpressionsHeaders;
    },
    changeCoverageParameters(value) {
      console.log("changeCoverageParameters: ", JSON.stringify(value));
      this.selectedItem.ConfigurationParameters = value;
      this.isChanged = true;
    },
    changeMemberFields(fields) {
      this.selectedItem.MemberDataFields = fields;
      // this.isChanged = true;
      this.loadMemberLogicalExpressionsFields();
      this.loadLogicalExpressionsFields();
    },
    changeMemberGroups(val) {
      // selectedItem.MemberGroups = $event
      this.selectedItem.MemberGroups = val;
      const eligibilityHourBankSettings =
        this.selectedItem.EligibilityHourBankSettings !== null &&
        this.selectedItem.EligibilityHourBankSettings !== undefined
          ? JSON.parse(JSON.stringify(this.selectedItem.EligibilityHourBankSettings))
          : [];
      for (let s of eligibilityHourBankSettings) {
        if (s.MemberGroup) {
          const existing = this.selectedItem.MemberGroups.filter(
            (o) => o.Identifier === s.MemberGroup.Identifier
          );
          if (existing.length > 0) {
            s.MemberGroup = existing[0];
          } else {
            delete s.MemberGroup;
          }
        }
      }
      this.selectedItem.EligibilityHourBankSettings = eligibilityHourBankSettings;
      const selfPaymentSettings =
        this.selectedItem.SelfPaymentSettings !== null &&
        this.selectedItem.SelfPaymentSettings !== undefined
          ? JSON.parse(JSON.stringify(this.selectedItem.SelfPaymentSettings))
          : [];
      for (let s of selfPaymentSettings) {
        if (s.MemberGroup) {
          const existing = this.selectedItem.MemberGroups.filter(
            (o) => o.Identifier === s.MemberGroup.Identifier
          );
          if (existing.length > 0) {
            s.MemberGroup = existing[0];
          } else {
            delete s.MemberGroup;
          }
        }
      }
      this.selectedItem.SelfPaymentSettings = selfPaymentSettings;
      this.isChanged = true;
    },
    changeEligibilityHourBankSettings(val) {
      this.selectedItem.EligibilityHourBankSettings = val;
      this.isChanged = true;
    },
    changeSelfPaymentSettings(val) {
      console.log("val is: --------------------------------------------------------------------------", JSON.stringify(val));
      this.selectedItem.SelfPaymentSettings = val;
      this.isChanged = true;
    },
    changeEmployers(employers) {
      // selectedItem.Employers = $event
      this.selectedItem.GeneralSettings.PlanSettings.HasStores = false;
      for (const employer of employers) {
        if (employer.Stores && employer.Stores.length > 0) {
          this.selectedItem.GeneralSettings.PlanSettings.HasStores = true;
          break;
        }
      }
      if (!this.selectedItem.GeneralSettings.PlanSettings.HasStores) {
        this.selectedItem.GeneralSettings.PlanSettings.ReportsPerStore = false;
      }
      this.selectedItem.Employers = employers;
      this.isChanged = true;
      console.log(this.selectedItem.BillingTerm);

      // const billingTerms =
      //   this.selectedItem.BillingTerm !== null &&
      //   this.selectedItem.BillingTerm !== undefined
      //     ? JSON.parse(JSON.stringify(this.selectedItem.BillingTerm))
      //     : [];

      // for (let term of billingTerms) {
      //   const existing = employers.filter(
      //     (o) => o.Identifier === term.Employer.Identifier
      //   );
      //   if (existing.length === 0) {
      //     term.EmployerId = undefined;
      //     delete term.Employer;
      //   } else {
      //     term.Employer = existing[0];
      //   }
      // }
      this.selectedItem.BillingTerm = this.selectedItem.BillingTerm.filter(
        (o) =>
          employers.filter((e) => e.Identifier === o.Employer.Identifier)
            .length > 0
      );
      let stores = employers.map((o) => o.Stores).flat();
      console.log(stores);
      this.selectedItem.BillingTerm = this.selectedItem.BillingTerm.map((o) => {
        o.Employer = employers.filter(
          (e) => e.Identifier === o.Employer.Identifier
        )[0];
        // o.Store = employers.filter(e=>e.Identifier === o.Employer.Identifier)[0];
        return o;
      });
      // this.selectedItem.BillingTerm = billingTerms;
      const contributionCategories =
        this.selectedItem.ContributionCategories !== null &&
        this.selectedItem.ContributionCategories !== undefined
          ? JSON.parse(JSON.stringify(this.selectedItem.ContributionCategories))
          : [];
      for (let category of contributionCategories) {
        if (category.Employers) {
          const existing = employers.filter(
            (o) =>
              category.Employers.filter((e) => o.Identifier === e.Identifier)
                .length > 0
          );
          category.Employers = existing;
        }
        if (category.Stores) {
          const existing = stores.filter(
            (o) =>
              category.Stores.filter((e) => o.Identifier === e.Identifier)
                .length > 0
          );
          category.Stores = existing;
        }
      }
      this.selectedItem.ContributionCategories = contributionCategories
        .filter((o) => o.Employers.length > 0 || o.Stores.length > 0)
        .map((o) => {
          o.Employers = o.Employers.map((oo) => {
            oo = employers.filter((e) => e.Identifier === oo.Identifier)[0];
            return oo;
          });
          o.Stores = o.Stores.map((oo) => {
            oo = stores.filter((e) => e.Identifier === oo.Identifier)[0];
            return oo;
          });
          return o;
        });

      // const coverage =
      //   this.selectedItem.Coverage !== null &&
      //   this.selectedItem.Coverage !== undefined
      //     ? JSON.parse(JSON.stringify(this.selectedItem.Coverage))
      //     : [];
      // for (let cov of coverage) {
      //   if (cov.Employers) {
      //     const existing = employers.filter(
      //       (o) =>
      //         cov.Employers.filter((e) => o.Identifier === e.Identifier)
      //           .length > 0
      //     );
      //     cov.Employers = existing;
      //   }
      // }
      // this.selectedItem.Coverage = coverage
        // // .filter((o) => o.Employers.length > 0)
        // .map((o) => {
        //   if (o.Employers) {
        //     o.Employers = o.Employers.map((oo) => {
        //       oo = employers.filter((e) => e.Identifier === oo.Identifier)[0];
        //       return oo;
        //     });
        //   }
        //   return o;
        // });

      const memberGroups =
        this.selectedItem.MemberGroups !== null &&
        this.selectedItem.MemberGroups !== undefined
          ? JSON.parse(JSON.stringify(this.selectedItem.MemberGroups))
          : [];
      for (let mg of memberGroups) {
        if (mg.Employers) {
          const existing = employers.filter(
            (o) =>
              mg.Employers.filter((e) => o.Identifier === e.Identifier)
                .length > 0
          );
          mg.Employers = existing;
        }
      }
      this.selectedItem.MemberGroups = memberGroups
        // .filter((o) => o.Employers.length > 0)
        .map((o) => {
          if (o.Employers) {
            o.Employers = o.Employers.map((oo) => {
              oo = employers.filter((e) => e.Identifier === oo.Identifier)[0];
              return oo;
            });
          }
          return o;
        });
    },
    changeCoverage(coverage) {
      this.selectedItem.Coverages = coverage;
      const params = this.selectedItem.ConfigurationParameters.filter((p) => {
        return (
          (p.ConfigurationParameter.CoverageIdentity !== null &&
            p.ConfigurationParameter.CoverageIdentity !== undefined &&
            coverage.filter(
              (o) =>
                o.Identifier ===
                p.ConfigurationParameter.CoverageIdentity.Identifier
            ).length > 0) ||
          p.ConfigurationParameter.CoverageIdentity === null ||
          p.ConfigurationParameter.CoverageIdentity === undefined
        );
      });
      for (let param of params) {
        if (
          param.ConfigurationParameter.CoverageIdentity !== null &&
          param.ConfigurationParameter.CoverageIdentity !== undefined
        ) {
          const existing = this.selectedItem.Coverages.filter(
            (o) =>
              o.Identifier ===
              param.ConfigurationParameter.CoverageIdentity.Identifier
          );
          if (existing.length > 0) {
            param.ConfigurationParameter.CoverageIdentity = {
              Current: {},
            };
            param.ConfigurationParameter.CoverageIdentity.Current.Name =
              existing[0].Name;
            param.ConfigurationParameter.CoverageIdentity.Current.Translations =
              existing[0].Translations;
            param.ConfigurationParameter.CoverageIdentity.Identifier =
              existing[0].Identifier;
          }
        }
      }
      this.selectedItem.ConfigurationParameters = params;
      console.log(
        "%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%"
      );
      console.log(JSON.stringify(formulas));
      const formulas = this.selectedItem.CalculationFormulas.filter(
        (o) =>
          o.CoverageIdentity === null ||
          o.CoverageIdentity === undefined ||
          o.CoverageIdentityId === o.PlanIdentityId ||
          this.selectedItem.Coverages.filter(
            (c) => c.Identifier === o.CoverageIdentity.Identifier
          ).length > 0
      );
      console.log(JSON.stringify(formulas));
      for (let formula of formulas) {
        if (
          formula.CoverageIdentity !== null &&
          formula.CoverageIdentity !== undefined
        ) {
          const existing = this.selectedItem.Coverages.filter(
            (o) => o.Identifier === formula.CoverageIdentity.Identifier
          );
          if (existing.length > 0) {
            formula.CoverageIdentity = existing[0];
          }
        }
      }

      this.selectedItem.CalculationFormulas = formulas;
      const memberGroups = JSON.parse(
        JSON.stringify(this.selectedItem.MemberGroups)
      );
      for (let group of memberGroups) {
        console.log(
          "------------------------------------",
          JSON.stringify(group.CoverageIdentities),
          this.selectedItem.Coverages
        );
        let groupCoverage = group.CoverageIdentities.filter(
          (gc) =>
            this.selectedItem.Coverages.filter(
              (o) => o.Identifier === gc.Identifier
            ).length > 0
        );
        group.CoverageIdentities = groupCoverage.map((gc) => {
          const existing = this.selectedItem.Coverages.filter(
            (o) => o.Identifier === gc.Identifier
          );
          if (existing.length > 0) {
            if (gc.Current === null || gc.Current === undefined) {
              gc.Current = {};
            }
            gc.Current.Name = existing[0].Name;
            gc.Current.Translations = existing[0].Translations;
          }
          return gc;
        });
      }
      this.selectedItem.MemberGroups = memberGroups;
      if (
        this.selectedItem.Eligibility &&
        this.selectedItem.Eligibility.BenefitRules
      ) {
        for (let rule of this.selectedItem.Eligibility.BenefitRules) {
          const existing = this.selectedItem.Coverages.filter(
            (o) => o.Identifier === rule.Coverage.Identifier
          );
          if (existing.length > 0) {
            rule.Coverage = existing[0];
          } else {
            rule.Coverage = undefined;
          }
        }
      }
      const coverageGroups = JSON.parse(JSON.stringify(this.coverageGroups));
      for (let group of coverageGroups) {
        const existing = this.selectedItem.Coverages.filter(
          (o) =>
            group.Coverage.filter((gc) => gc.Identifier === o.Identifier)
              .length > 0
        );
        if (existing.length > 0) {
          group.Coverage = existing;
        } else {
          group.Coverage = [];
        }
      }
      this.coverageGroups = coverageGroups;
      // this.isChanged=true;
    },
    changeTrustFund(trustFund) {
      this.selectedItem.TrustFund = trustFund;
      const coverages = JSON.parse(JSON.stringify(this.selectedItem.Coverages));
      for (let coverage of coverages) {
        if (coverage.TrustFund !== null && coverage.TrustFund !== undefined) {
          coverage.TrustFund = trustFund;
        }
      }
      // this.isChanged=true;
      this.selectedItem.Coverages = coverages;
    },
    changeInsuranceCarriers(planInsuranceCarriers) {
      // console.log("plan insurance carriers changed", planInsuranceCarriers)
      this.selectedItem.PlanInsuranceCarriers = planInsuranceCarriers;
      const coverages = JSON.parse(JSON.stringify(this.selectedItem.Coverages));
      for (let coverage of coverages) {
        if (
          coverage.PlanInsuranceCarrier !== null &&
          coverage.PlanInsuranceCarrier !== undefined
        ) {
          if (
            planInsuranceCarriers === null ||
            planInsuranceCarriers === undefined ||
            planInsuranceCarriers.length === 0 ||
            planInsuranceCarriers.filter(
              (o) => o.Identifier === coverage.PlanInsuranceCarrier.Identifier
            ).length === 0
          ) {
            coverage.PlanInsuranceCarrierId = undefined;
            delete coverage.PlanInsuranceCarrier;
          } else {
            coverage.PlanInsuranceCarrier = planInsuranceCarriers.filter(
              (o) => o.Identifier === coverage.PlanInsuranceCarrier.Identifier
            )[0];
          }
        }
      }
      // this.isChanged=true;
      this.selectedItem.Coverages = coverages;
    },
    getTranslatedField(translations, key) {
      if (!translations) throw new Error("no translations");
      for (let row of translations) {
        if (!Object.keys(row).indexOf(key) < 0) return "";
        return row[key];
      }
      throw new Error("no translations");
    },
    onWindowSizeChanged() {
      this.onScroll();
    },
    onScroll() {
      clearTimeout(this.timeoutResult);
      this.timeoutResult = setTimeout(() => {
        if (
          this.$refs.container === undefined ||
          this.$el.querySelector === undefined
        ) {
          return;
        }
        const materialCardElement = document.getElementById(
          "plan_builder_view_material_card"
        );
        if (materialCardElement === null || materialCardElement === undefined) {
          return;
        }
        const rect = materialCardElement.getBoundingClientRect();
        const bottomVisible = this.isElementInViewport(
          document.getElementById("bottom-actions")
        );
        const materialCardTopVisible =
          (rect.top < 98 &&
            !bottomVisible &&
            this.$refs.creationWizard.panels.length === 0) ||
          (rect.top < 98 && this.$refs.creationWizard.panels.length > 0);
        if (!materialCardTopVisible) {
          this.isFixedActionsBarVisible = false;
          return;
        }
        this.isFixedActionsBarVisible = true;
      }, 100);
    },
    isElementInViewport(el) {
      var rect = el.getBoundingClientRect();
      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <=
          (window.innerHeight ||
            document.documentElement
              .clientHeight) /* or $(window).height() */ &&
        rect.right <=
          (window.innerWidth ||
            document.documentElement.clientWidth) /* or $(window).width() */
      );
    },
    async init() {
      this.loadingPlan = true;
      try {
        this.organization = (
          await this.getOrganizationById({
            id: this.$route.params.broker,
          })
        ).data;
        let draftId = this.$route.params.plan;
        await this.loadPlan(draftId);
        this.status = this.$route.params.status;
        // console.log(JSON.stringify(this.selectedItem));
        this.brokers = (
          await this.getOrganizationBrokers({
            id: this.$route.params.broker,
          })
        ).data.value;
        this.calculationEntitiesFormulaTypes = (
          await this.getCalculationEntitiesFormulaTypes()
        ).data;
        if (
          this.selectedItem &&
          this.selectedItem.MemberDataFields &&
          this.selectedItem.GeneralSettings &&
          this.selectedItem.GeneralSettings.PlanSettings
        ) {
          this.planVariables = await this.getPlanVariablesBuilder({
            planIdentityId: this.planIdentityId, //"c8380bca-674d-46b1-97c7-64dea63784c6",
            payload: {
              Fields: this.selectedItem.MemberDataFields.map((o) => o.Key),
              Coverages: JSON.parse(
                JSON.stringify(this.selectedItem.Coverages)
              ).map((o) => {
                delete o.TrustFund;
                return o;
              }),
              TrackHours: this.selectedItem.GeneralSettings.TrackHours,
              HasStores:
                this.selectedItem.GeneralSettings.PlanSettings.HasStores,
            },
          });
        }
        this.taxParameters = await this.getAllTaxParameters();

        this.allMemberFields = (
          await this.getMemberFields(this.planIdentityId)
        ).data;

        this.fixMemberFields();

        if (this.hasClasses) {
          this.classesArray = JSON.parse(
            this.selectedItem.GeneralSettings.PlanSettings.Classes
          );
        } else {
          this.classesArray = [];
        }

        console.log(
          "##############################################",
          JSON.stringify(this.selectedItem)
        );

        this.allDemographicsFields = (
          await this.getDemographicsFields({
            planIdentityId: this.planIdentityId,
            payload: this.selectedItem.MemberDataFields.map((o) => o.Key),
          })
        ).data;

        this.allBillingImportFields = (
          await this.getBillingImportFields({
            planIdentityId: this.planIdentityId,
            payload: this.selectedItem.MemberDataFields.map((o) => o.Key),
          })
        ).data;

        this.insuranceCarriers = (
          await this.getAllInsuranceCarriers()
        ).data.sort(function (a, b) {
          return a.Name < b.Name;
        });

        this.uniqueIdentifiers = (
          await this.getPlanUniqueIdentifiersById({
            draftId: this.draftId,
          })
        ).data;

        this.claimParameters = (await this.getClaimParameters()).data;
      } catch (error) {
        this.error = error;
        this.exitWithoutWarning = true;
      } finally {
        this.loadingPlan = false;
      }
    },
    fixMemberFields() {
      if (this.hasClasses) {
        this.memberFields = JSON.parse(JSON.stringify(this.allMemberFields));
        if (
          this.selectedItem.MemberDataFields.filter((o) => o.Key === "Class")
            .length === 0
        ) {
          let field = this.memberFields.filter((o) => o.Key === "Class")[0];
          if (field !== undefined && field !== null) {
            this.selectedItem.MemberDataFields.push(field);
          }
        }
      } else {
        this.memberFields = this.allMemberFields.filter(
          (o) => o.Key !== "Class"
        );
        this.selectedItem.MemberDataFields =
          this.selectedItem.MemberDataFields.filter((o) => o.Key !== "Class");
      }

      if (this.hasOccupations) {
        if (
          this.selectedItem.MemberDataFields.filter(
            (o) => o.Key === "Occupation"
          ).length === 0
        ) {
          let field = this.memberFields.filter(
            (o) => o.Key === "Occupation"
          )[0];
          this.selectedItem.MemberDataFields.push(field);
        }
      } else {
        this.memberFields = this.memberFields.filter(
          (o) => o.Key !== "Occupation"
        );
        this.selectedItem.MemberDataFields =
          this.selectedItem.MemberDataFields.filter(
            (o) => o.Key !== "Occupation"
          );
      }

      this.loadMemberLogicalExpressionsFields();
      this.loadLogicalExpressionsFields();
    },
    displayWarning(next) {
      if (!this.isChanged) {
        this.exitWithoutWarning = true;
      }
      this.dialogs.warningResult = null;
      if (this.exitWithoutWarning) {
        next();
      } else {
        this.routeData = {
          next: next,
        };
        this.dialogs.warning = true;
      }
    },
    async loadPlan(id) {
      // try {

      let response = await this.lock(
        this.getPlanById,
        {
          plan: id,
          warning: true,
        },
        // () => {
        //   this.$router.push({
        //     name: "plans",
        //     params: { broker: this.broker.Id },
        //   });
        // },
        null,
        true,
        true
      );
      if (response.status === 204) {
        this.selectedItem = {
          GeneralSettings: {
            Broker: this.organization,
            Client: {},
            PlanSettings: {
              Term: {},
              DueDate: {},
            },
            CertificateLength: 9
          },
          PlanInsuranceCarriers: [],
          TrustFund: {
            Contacts: [],
            BankAccount: {},
          },
          Employers: [],
          Flags: [],
          MemberDataFields: [],
          Contacts: [],
          Coverages: [],
          ConfigurationParameters: [],
          CalculationFormulas: [],
          MemberGroups: [],
          ReportConfiguration: {
            InheritedBrokerAddress: true,
            ReportConfiguration: {},
          },
          DemographicFields: [],
          BillingImportFields: [],
          Eligibility: {
            MemberEligibility: {},
            SickPaymentBankEligibility: {},
          },
          BillingTerm: [],
          ContributionCategories: [],
          HoursSetup: {
            PrimaryHourImportMemberIdentifier: null,
            CandidateHourImportMemberIdentifiers: [],
            IncludeContributionAmount: false,
          },
          EligibilityHourBankSettings:[],
          SelfPaymentSettings: []
        };
        this.savedEligibility = false;
      } else {
        let draftPlan = response.data;
        let item = draftPlan.PlanData;
        this.planType = draftPlan.PlanType;
        if (this.planType === "HW") {
          if (!item.MemberGroups) {
            item.MemberGroups = [];
          }
          if (!item.EligibilityHourBankSettings) {
            item.EligibilityHourBankSettings = [];
          }
          if (!item.SelfPaymentSettings) {
            item.SelfPaymentSettings = [];
          }
          if (!item.ReportConfiguration) {
            item.ReportConfiguration = {};
          }
          if (!item.GeneralSettings.Client) {
            item.GeneralSettings.Client = {};
          }
          if (!item.GeneralSettings.PlanSettings.Term) {
            item.GeneralSettings.PlanSettings.Term = {};
          }
          if (!item.GeneralSettings.PlanSettings.DueDate) {
            item.GeneralSettings.PlanSettings.DueDate = {};
          }
          if (item.GeneralSettings.PlanSettings.Classes) {
            this.hasClasses = true;
            this.classesStr = item.GeneralSettings.PlanSettings.Classes.replace(
              /\[/g,
              ""
            )
              .replace(/\]/g, "")
              .replace(/"/g, "");
            this.classesArray = JSON.parse(
              item.GeneralSettings.PlanSettings.Classes
            );
          }
          if (item.GeneralSettings.Occupations) {
            this.hasOccupations = true;
            this.occupationsStr = item.GeneralSettings.Occupations.replace(
              /\[/g,
              ""
            )
              .replace(/\]/g, "")
              .replace(/"/g, "");
          }
          if (item.GeneralSettings.StartingCertificateNumber) {
            item.GeneralSettings.StartingCertificateNumber = item.GeneralSettings.StartingCertificateNumber.toString();
            let zeros = "";
            for (let i=item.GeneralSettings.StartingCertificateNumber.length;i<item.GeneralSettings.CertificateLength-3;i++) {
              zeros +="0";
            }
            item.GeneralSettings.StartingCertificateNumber = zeros + item.GeneralSettings.StartingCertificateNumber;
          }
          if (!item.ReportConfiguration.ReportConfiguration) {
            item.ReportConfiguration.ReportConfiguration = {};
          }
          for (let ic of item.PlanInsuranceCarriers) {
            ic.Name =
              ic.InsuranceCarrier.Translations.filter(
                (o) => o.LanguageCode === this.language.language
              ).length > 0
                ? ic.InsuranceCarrier.Translations.filter(
                    (o) => o.LanguageCode === this.language.language
                  )[0].Name
                : ic.InsuranceCarrier.Name;
          }
          if (
            item.ReportConfiguration.BrokerCity === null ||
            item.ReportConfiguration.BrokerCity === undefined ||
            (item.ReportConfiguration.BrokerCity === this.organization.City &&
              item.ReportConfiguration.BrokerPostalCode ===
                this.organization.PostalCode &&
              item.ReportConfiguration.BrokerProvince ===
                this.organization.Province.Name &&
              item.ReportConfiguration.BrokerStreetName ===
                this.organization.StreetName &&
              item.ReportConfiguration.BrokerStreetNumber ===
                this.organization.StreetNumber &&
              item.ReportConfiguration.BrokerSuiteNumber ===
                this.organization.SuiteNumber &&
              item.ReportConfiguration.BrokerLogo ===
                this.organization.BrokerLogo)
          ) {
            item.ReportConfiguration.InheritedBrokerAddress = true;
          } else {
            //    reportConfiguration.BrokerCity =
            //   this.reportConfigurationAddress.Address.City;
            // reportConfiguration.BrokerPostalCode =
            //   this.reportConfigurationAddress.Address.PostalCode;
            // // reportConfiguration.BrokerPostalCode = this.unmask(this.reportConfigurationAddress.Address.PostalCode, this.postalCodeMask);
            // reportConfiguration.BrokerProvince =
            //   this.reportConfigurationAddress.Address.Province.Name;
            // reportConfiguration.BrokerStreetName =
            //   this.reportConfigurationAddress.Address.StreetName;
            // reportConfiguration.BrokerStreetNumber =
            //   this.reportConfigurationAddress.Address.StreetNumber;
            // reportConfiguration.BrokerSuiteNumber =
            //   this.reportConfigurationAddress.Address.SuiteNumber;
            this.reportConfigurationAddress = {
              Address: {
                City: item.ReportConfiguration.BrokerCity,
                PostalCode: item.ReportConfiguration.BrokerPostalCode,
                Province: this.options.Models.Province.filter(
                  (o) => o.Name === item.ReportConfiguration.BrokerProvince
                )[0],
                StreetName: item.ReportConfiguration.BrokerStreetName,
                StreetNumber: item.ReportConfiguration.BrokerStreetNumber,
                SuiteNumber: item.ReportConfiguration.BrokerSuiteNumber,
              },
            };
          }
          if (
            item.DemographicFields === null ||
            item.DemographicFields === undefined
          ) {
            item.DemographicFields = [];
          }
          if (item.GeneralSettings.PlanSettings.HasBillingImport) {
            if (
              item.BillingImportFields === null ||
              item.BillingImportFields === undefined
            ) {
              item.BillingImportFields = [];
            } else {
              for (let field of item.BillingImportFields) {
                field.Label = field.Label.replace(" (optional)", "");
                field.Label = field.Label.replace(" (required)", "");
                if (field.IsOptional) {
                  field.Label = field.Label + " (optional)";
                } else {
                  field.Label = field.Label + " (required)";
                }
              }
            }
          }
          if (item.GeneralSettings.PlanSettings.HasBilling) {
            if (item.BillingTerm === null || item.BillingTerm === undefined) {
              item.BillingTerm = [];
            }
            if (
              item.ContributionCategories === null ||
              item.ContributionCategories === undefined
            ) {
              item.ContributionCategories = [];
            }
          }
          if (item.GeneralSettings.HasEligibility || item.GeneralSettings.HasEligibilityBank) {
            if (item.Eligibility === null || item.Eligibility === undefined) {
              item.Eligibility = {
                ActivityStatusRules: [],
                BenefitRules: [],
                EligibilityPeriodRules: [],
                CoverageCommencementRules: [],
                MemberCoverageEligibilityRules: [],
                MemberEligibility: {},
                SickPaymentBankEligibility: {},
              };
            }
            if (
              item.Eligibility.MemberEligibility === null ||
              item.Eligibility.MemberEligibility === undefined
            ) {
              item.Eligibility.MemberEligibility = {};
            }
            if (
              item.Eligibility.SickPaymentBankEligibility === null ||
              item.Eligibility.SickPaymentBankEligibility === undefined
            ) {
              item.Eligibility.SickPaymentBankEligibility = {};
            }
            if (
              item.Eligibility.EligibilityPeriodRules === null ||
              item.Eligibility.EligibilityPeriodRules === undefined
            ) {
              item.Eligibility.EligibilityPeriodRules = [];
            }
            if (
              item.Eligibility.ActivityStatusRules === null ||
              item.Eligibility.ActivityStatusRules === undefined
            ) {
              item.Eligibility.ActivityStatusRules = [];
            } else {
              for (let rule of item.Eligibility.ActivityStatusRules) {
                if (
                  rule.CoverageIdentities === null ||
                  rule.CoverageIdentities === undefined
                ) {
                  rule.CoverageIdentities = [];
                }
                rule.CoverageIdentities = rule.CoverageIdentities.filter(
                  (o) =>
                    item.Coverages.filter((c) => c.Identifier === o.Identifier)
                      .length > 0
                );
              }
            }
            if (
              item.Eligibility.BenefitRules === null ||
              item.Eligibility.BenefitRules === undefined
            ) {
              item.Eligibility.BenefitRules = [];
            } else {
              for (let rule of item.Eligibility.BenefitRules) {
                rule.Classes = JSON.parse(rule.Classes);
              }
            }
            if (
              item.Eligibility.EligibilityPeriodRules === null ||
              item.Eligibility.EligibilityPeriodRules === undefined
            ) {
              item.Eligibility.EligibilityPeriodRules = [];
            }
            if (
              item.Eligibility.CoverageCommencementRules === null ||
              item.Eligibility.CoverageCommencementRules === undefined
            ) {
              item.Eligibility.CoverageCommencementRules = [];
            }
            if (
              item.Eligibility.MemberCoverageEligibilityRules === null ||
              item.Eligibility.MemberCoverageEligibilityRules === undefined
            ) {
              item.Eligibility.MemberCoverageEligibilityRules = [];
            }
            if (item.SelfPaymentSettings === null ||
              item.SelfPaymentSettings === undefined) {
              item.SelfPaymentSettings =[];
            }
            for (let s of item.SelfPaymentSettings) {
              s.Identifier = Math.random().toString();
              for (let c of s.SelfPaymentConditions) {
                c.Identifier = Math.random().toString();
              }
            }
          }

          if (item.Coverages) {
            let coverageGroups = [];
            for (const cov of item.Coverages) {
              if (cov.CoverageGroup) {
                let existing = coverageGroups.filter(
                  (o) => o.Name === cov.CoverageGroup
                );
                if (existing.length > 0) {
                  existing[0].Coverage.push(JSON.parse(JSON.stringify(cov)));
                } else {
                  coverageGroups.push({
                    Identifier: Math.random().toString(),
                    Name: cov.CoverageGroup,
                    Coverage: [JSON.parse(JSON.stringify(cov))],
                  });
                }
              }
            }

            if (coverageGroups.length > 0) {
              this.additionalDataGrouping = "Coverage Groups";
            }
            this.coverageGroups = coverageGroups;

            for (let c of item.Coverages) {
              if (c.TracksDependants === true) {
                c.TracksDependantsEnum =
                  this.options.Enums.DependantTracking.filter(
                    (o) => o === "ByName"
                  )[0];
              } else if (c.TracksDependants === false) {
                c.TracksDependantsEnum =
                  this.options.Enums.DependantTracking.filter(
                    (o) => o === "ByNumber"
                  )[0];
              } else {
                c.TracksDependantsEnum = null;
              }
            }
          }

          for (let c of item.ConfigurationParameters) {
              if (c.ConfigurationParameter.CoverageStatusId!==null && c.ConfigurationParameter.CoverageStatusId!==undefined) {
                c.ConfigurationParameter.CoverageStatus =
                  this.options.Models.FamilyStatus.filter(
                    (o) => o.Id === c.ConfigurationParameter.CoverageStatusId
                  )[0];
              }
            }

          if (item.ReportConfiguration.ReportConfiguration.GroupByClass) {
            this.defaultDataGrouping = "Classes";
          } else {
            this.defaultDataGrouping = "Member Groups";
          }

          for (let insuranceCarrier of item.PlanInsuranceCarriers) {
            if (
              insuranceCarrier.Address !== null &&
              insuranceCarrier.Address !== undefined &&
              insuranceCarrier.Address.ProvinceId !== null &&
              insuranceCarrier.Address.ProvinceId !== undefined &&
              insuranceCarrier.Address.ProvinceId !==
                "00000000-0000-0000-0000-000000000000"
            ) {
              insuranceCarrier.Address.Province =
                this.options.Models.Province.filter(
                  (o) => o.Id === insuranceCarrier.Address.ProvinceId
                )[0];
            }
          }
        } else if (this.planType === "Pension") {
          if (!item.Unions) {
            item.Unions = [];
          }
        } else if (this.planType === "NoManaged") {
          if (!item.GeneralSettings.Client) {
            item.GeneralSettings.Client = {};
          }
        }
        item.MemberDataFields = item.MemberDataFields.map((o) => {
          const name = o.IsOptional
            ? `${o.Label} (optional)`
            : `${o.Label} (required)`;
          o.Label = o.Label.indexOf("(") === -1 ? name : o.Label;
          return o;
        });
        for (let employer of item.Employers) {
          if (
            employer.Address !== null &&
            employer.Address !== undefined &&
            employer.Address.ProvinceId !== null &&
            employer.Address.ProvinceId !== undefined &&
            employer.Address.ProvinceId !==
              "00000000-0000-0000-0000-000000000000"
          ) {
            employer.Address.Province = this.options.Models.Province.filter(
              (o) => o.Id === employer.Address.ProvinceId
            )[0];
          }
          if (employer.Stores !== null && employer.Stores !== undefined) {
            for (let store of employer.Stores) {
              if (
                store.Address !== null &&
                store.Address !== undefined &&
                store.Address.ProvinceId !== null &&
                store.Address.ProvinceId !== undefined &&
                store.Address.ProvinceId !==
                  "00000000-0000-0000-0000-000000000000"
              ) {
                store.Address.Province = this.options.Models.Province.filter(
                  (o) => o.Id === store.Address.ProvinceId
                )[0];
              }
            }
          }
        }
        if (item.HoursSetup === null || item.HoursSetup === undefined) {
          item.HoursSetup = {
            PrimaryHourImportMemberIdentifier: null,
            CandidateHourImportMemberIdentifiers: [],
            IncludeContributionAmount: false,
          };
        }
        if (item.TrustFund === null || item.TrustFund === undefined) {
          item.TrustFund = {
            Contacts: [],
            BankAccount: {},
          };
        }
        console.log(item.TrustFund);
        if (
          item.TrustFund.BankAccount === null ||
          item.TrustFund.BankAccount === undefined
        ) {
          item.TrustFund.BankAccount = {};
        }
        if (
          item.TrustFund.Address !== null &&
          item.TrustFund.Address !== undefined &&
          item.TrustFund.Address.ProvinceId !== null &&
          item.TrustFund.Address.ProvinceId !== undefined &&
          item.TrustFund.Address.ProvinceId !==
            "00000000-0000-0000-0000-000000000000"
        ) {
          item.TrustFund.Address.Province = this.options.Models.Province.filter(
            (o) => o.Id === item.TrustFund.Address.ProvinceId
          )[0];
        }
        this.selectedItem = item;
        this.planIdentityId = item.GeneralSettings.PlanSettings.IdentityId;
        for (let union of item.Unions) {
          for (let local of union.Locals) {
            if (!local.Identifier) {
              local.Identifier = Math.random().toString();
            }
            if (
              local.Address !== null &&
              local.Address !== undefined &&
              local.Address.ProvinceId !== null &&
              local.Address.ProvinceId !== undefined &&
              local.Address.ProvinceId !==
                "00000000-0000-0000-0000-000000000000"
            ) {
              local.Address.Province = this.options.Models.Province.filter(
                (o) => o.Id === local.Address.ProvinceId
              )[0];
            }
          }
        }
      }

      this.draftId = id;
      this.isNew = false;
    },
    async finalizeDraft() {
      this.loadingPlan = true;
      try {
        // await this.lock(this.activatePlan, {
        //   broker: this.broker.Id,
        //   plan: this.planIdentityId,
        // });
        await this.activatePlan({
          broker: this.organization.Id,
          plan: this.planIdentityId,
        });
        this.color = "success";
        this.message = this.$t("views.planwizardview.activate_success_{0}", [
          this.selectedItem.GeneralSettings.UniqueIdentifier,
        ]);
        this.snackbar = true;
        this.planIdentityId = "00000000-0000-0000-0000-000000000000";
        this.dialogs.activateWarning = false;
        setTimeout(() => {
          this.$router.push({
            name: "plans",
            params: { broker: this.$route.params.broker },
          });
        }, 3500);
      } catch (error) {
        this.error = error;
      } finally {
        this.loadingPlan = false;
        // this.unlock();
      }
    },
    async testDraft() {
      this.saving = true;
      try {
        // await this.lock(this.testPlan, {
        //   broker: this.broker.Id,
        //   plan: this.draftId,
        // });
        await this.testPlan({
          broker: this.organization.Id,
          plan: this.draftId,
        });
        this.color = "success";
        this.message = this.$t("views.planwizardview.test_success_{0}", [
          this.selectedItem.GeneralSettings.UniqueIdentifier,
        ]);
        this.snackbar = true;
        this.planIdentityId = "00000000-0000-0000-0000-000000000000";
        this.dialogs.test = false;
        this.dialogs.draftWarning = false;
        if (this.selectedItem.GeneralSettings.PlanSettings.HasSickPaymentBank) {
          this.dialogs.sickDayWarning = true;
        } else {
          setTimeout(() => {
          this.$router.push({
            name: "plans",
            params: { broker: this.$route.params.broker },
          });
        }, 3500);
        }
      } catch (error) {
        this.error = error;
      } finally {
        this.saving = false;
        // this.unlock();
      }
    },
    closeSickDayWarning() {
      this.dialogs.sickDayWarning = false;
      this.$router.push({
            name: "plans",
            params: { broker: this.$route.params.broker },
          });
    },
    validChanged(valid) {
      console.log("builder valid changed: ", valid);
      this.builderValid = valid;
    },
    fixPayloadForPost() {
      let generalSettings = JSON.parse(
        JSON.stringify(this.selectedItem.GeneralSettings)
      );
      if (!generalSettings.PlanSettings.Name) {
        generalSettings.PlanSettings.Name = this.getTranslatedField(
          generalSettings.PlanSettings.Translations,
          "Name"
        );
      }
      if (!generalSettings.PlanSettings.Description) {
        generalSettings.PlanSettings.Description = this.getTranslatedField(
          generalSettings.PlanSettings.Translations,
          "Description"
        );
      }
      generalSettings.BrokerId = this.organization.Id;
      generalSettings.PlanSettings.StatusId = this.activeStatus;

      let employers = JSON.parse(JSON.stringify(this.selectedItem.Employers));
      for (let employer of employers) {
        employer.PlanIdentityId = this.planIdentityId;
        // employer.StatusId = this.activeParticipationStatus;
        if (employer.Status !== null && employer.Status !== undefined) {
          employer.StatusId = employer.Status.Id;
          // delete employer.Status;
        }
        if (employer.Address && Object.keys(employer.Address).length === 0) {
          employer.Address = null;
        }
        if (employer.Address) {
          if (employer.Address.Province) {
            employer.Address.ProvinceId = employer.Address.Province.Id;
            delete employer.Address.Province;
          }
          // employer.Address.PostalCode = this.unmask(employer.Address.PostalCode, this.postalCodeMask);
        }
        if (
          employer.PhoneNumber !== null &&
          employer.PhoneNumber !== undefined
        ) {
          employer.PhoneNumber = this.unmask(
            employer.PhoneNumber,
            this.telephoneMask
          );
        }
        if (
          employer.PhoneNumber2 !== null &&
          employer.PhoneNumber2 !== undefined
        ) {
          employer.PhoneNumber2 = this.unmask(
            employer.PhoneNumber2,
            this.telephoneMask
          );
        }
        if (employer.Fax !== null && employer.Fax !== undefined) {
          employer.Fax = this.unmask(employer.Fax, this.telephoneMask);
        }
        if (employer.Stores) {
          for (let store of employer.Stores) {
            store.Name = store.Translations.filter(
              (o) => o.LanguageCode === this.language.language
            )[0].Name;
            if (store.Address && Object.keys(store.Address).length === 0) {
              store.Address = null;
            }
            if (store.Address) {
              if (store.Address.Province) {
                store.Address.ProvinceId = store.Address.Province.Id;
                delete store.Address.Province;
              }
              // store.Address.PostalCode = this.unmask(store.Address.PostalCode, this.postalCodeMask);
            }
            if (store.PhoneNumber !== null && store.PhoneNumber !== undefined) {
              store.PhoneNumber = this.unmask(
                store.PhoneNumber,
                this.telephoneMask
              );
            }
            if (
              store.PhoneNumber2 !== null &&
              store.PhoneNumber2 !== undefined
            ) {
              store.PhoneNumber2 = this.unmask(
                store.PhoneNumber2,
                this.telephoneMask
              );
            }
            if (store.Fax !== null && store.Fax !== undefined) {
              store.Fax = this.unmask(store.Fax, this.telephoneMask);
            }
            // store.StatusId = this.activeParticipationStatus;
            if (store.Status !== null && store.Status !== undefined) {
              store.StatusId = store.Status.Id;
              // delete store.Status;
            }
            if (store.Contacts) {
              store.PlanIdentityId = this.planIdentityId;
              for (let contact of store.Contacts) {
                // delete contact.Status;
                contact.StatusId = this.activeStatus;
                contact.PlanIdentityId = this.planIdentityId;
                // if (contact.Title !== null && contact.Title !== undefined) {
                //   contact.TitleId = contact.Title.Id;
                //   delete contact.Title;
                // }
                if (
                  contact.PhoneNumber !== null &&
                  contact.PhoneNumber !== undefined
                ) {
                  contact.PhoneNumber = this.unmask(
                    contact.PhoneNumber,
                    this.telephoneMask
                  );
                }
                if (contact.Fax !== null && contact.Fax !== undefined) {
                  contact.Fax = this.unmask(contact.Fax, this.telephoneMask);
                }
              }
            }
          }
        }
        if (employer.Contacts) {
          for (let contact of employer.Contacts) {
            // delete contact.Status;
            contact.StatusId = this.activeStatus;
            contact.PlanIdentityId = this.planIdentityId;
            // if (contact.Title !== null && contact.Title !== undefined) {
            //   contact.TitleId = contact.Title.Id;
            //   delete contact.Title;
            // }
            if (
              contact.PhoneNumber !== null &&
              contact.PhoneNumber !== undefined
            ) {
              contact.PhoneNumber = this.unmask(
                contact.PhoneNumber,
                this.telephoneMask
              );
            }
            if (contact.Fax !== null && contact.Fax !== undefined) {
              contact.Fax = this.unmask(contact.Fax, this.telephoneMask);
            }
          }
        }
        employer.Name = employer.Translations.filter(
          (o) => o.LanguageCode === this.language.language
        )[0].Name;
        if (
          employer.PaymentDueDay !== null &&
          employer.PaymentDueDay !== undefined
        ) {
          employer.PaymentDueDayId = employer.PaymentDueDay.Id;
        } else {
          employer.PaymentDueDayId = null;
        }

        if (employer.Classes && !Array.isArray(employer.Classes)) {
          employer.Classes = JSON.parse(employer.Classes);
        }
        if (employer.Classes && employer.Classes.length > 0) {
          employer.Classes =
            "[" + employer.Classes.map((o) => `"${o}"`).join(",") + "]";
        }
      }
      let trustFund = JSON.parse(JSON.stringify(this.selectedItem.TrustFund));
      let bankAccount;
      if (trustFund && trustFund.BankAccount) {
        bankAccount = JSON.parse(
          JSON.stringify(this.selectedItem.TrustFund.BankAccount)
        );
      }

      if (!generalSettings.PlanSettings.IncludeTrustFund) {
        trustFund = undefined;
      }
      if (trustFund !== null && trustFund !== undefined) {
        console.log(trustFund);
        if (
          trustFund.Translations !== null &&
          trustFund.Translations !== undefined
        ) {
          trustFund.Name = trustFund.Translations.filter(
            (o) => o.LanguageCode === this.language.language
          )[0].Name;
        }
        if (trustFund.Address) {
          if (Object.keys(trustFund.Address).length === 0) {
            trustFund.Address = null;
          } else {
            if (trustFund.Address.Province) {
              trustFund.Address.ProvinceId = trustFund.Address.Province.Id;
              delete trustFund.Address.Province;
            }
            // trustFund.Address.PostalCode = unmask(trustFund.Address.PostalCode, postalCodeMask);
          }
        }

        if (
          trustFund.PhoneNumber !== null &&
          trustFund.PhoneNumber !== undefined
        ) {
          trustFund.PhoneNumber = this.unmask(
            trustFund.PhoneNumber,
            this.telephoneMask
          );
        }
        if (trustFund.Fax !== null && trustFund.Fax !== undefined) {
          trustFund.Fax = this.unmask(trustFund.Fax, this.telephoneMask);
        }

        for (let contact of trustFund.Contacts) {
          contact.StatusId = this.activeStatus;
          contact.PlanIdentityId = this.planIdentityId;
          // if (contact.Title !== null && contact.Title !== undefined) {
          //   contact.TitleId = contact.Title.Id;
          //   delete contact.Title;
          // }
          if (
            contact.PhoneNumber !== null &&
            contact.PhoneNumber !== undefined
          ) {
            contact.PhoneNumber = this.unmask(
              contact.PhoneNumber,
              this.telephoneMask
            );
          }
          if (contact.Fax !== null && contact.Fax !== undefined) {
            contact.Fax = this.unmask(contact.Fax, this.telephoneMask);
          }
        }

        if (trustFund.Policy) {
          trustFund.Policy.StatusId = this.activeStatus;
          trustFund.Policy.EffectiveDate =
            generalSettings.PlanSettings.EffectiveDate;
        }

        if (bankAccount && Object.keys(bankAccount).length > 0) {
          trustFund.BankAccount = bankAccount;
        } else {
          trustFund.BankAccount = undefined;
        }
      }
      let memberDataFields = JSON.parse(
        JSON.stringify(this.selectedItem.MemberDataFields)
      );

      let coverages = JSON.parse(JSON.stringify(this.selectedItem.Coverages));
      console.log(coverages);
      generalSettings.PlanSettings.HasCommissions = false;
      for (let coverage of coverages) {
        // delete coverage.Current;
        coverage.Name = coverage.Translations.filter(
          (o) => o.LanguageCode === this.language.language
        )[0].Name;
        coverage.Description = coverage.Translations.filter(
          (o) => o.LanguageCode === this.language.language
        )[0].Description;

        coverage.EffectiveDate = generalSettings.PlanSettings.EffectiveDate;

        if (coverage.TracksDependantsEnum === "ByName") {
          coverage.TracksDependants = true;
        } else if (coverage.TracksDependantsEnum === "ByNumber") {
          coverage.TracksDependants = false;
        } else {
          coverage.TracksDependants = null;
        }
        // delete coverage.TracksDependantsEnum;
        coverage.StatusId = this.activeStatus;
        if (coverage.HasCommissions) {
          generalSettings.PlanSettings.HasCommissions = true;
        }
        if (coverage.Broker) {
          coverage.BrokerId = coverage.Broker.Id;
        } else {
          coverage.BrokerId = null;
        }
        if (coverage.Employers) {
          for (let employer of coverage.Employers) {
            if (employer.Classes && !Array.isArray(employer.Classes)) {
              employer.Classes = JSON.parse(employer.Classes);
            }
            if (employer.Classes && employer.Classes.length > 0) {
              employer.Classes =
                "[" + employer.Classes.map((o) => `"${o}"`).join(",") + "]";
            }
          }
        }
      }

      let memberGroups = JSON.parse(
        JSON.stringify(this.selectedItem.MemberGroups)
      );
      for (let memberGroup of memberGroups) {
        memberGroup.EffectiveDate = generalSettings.PlanSettings.EffectiveDate;
        memberGroup.StatusId = this.activeStatus;
        memberGroup.Name = memberGroup.Translations.filter(
          (o) => o.LanguageCode === this.language.language
        )[0].Name;
        delete memberGroup.Status;
        // let coverageIdentities = [];
        // for (let coverage of memberGroup.CoverageIdentities) {
        //   if (coverage) {
        //     if (coverage.IdentityId) {
        //       coverageIdentities.push({
        //         Id: coverage.IdentityId,
        //         PlanIdentityId: this.plan,
        //       });
        //     } else {
        //       coverageIdentities.push({
        //         Id: coverage.Id,
        //         PlanIdentityId: this.plan,
        //       });
        //     }
        //   }
        // }
        // memberGroup.CoverageIdentities = coverageIdentities;
        if (memberGroup.Employers) {
          for (let employer of memberGroup.Employers) {
            if (employer.Classes && !Array.isArray(employer.Classes)) {
              employer.Classes = JSON.parse(employer.Classes);
            }
            if (employer.Classes && employer.Classes.length > 0) {
              employer.Classes =
                "[" + employer.Classes.map((o) => `"${o}"`).join(",") + "]";
            }
          }
        }
      }

      let flags = JSON.parse(JSON.stringify(this.selectedItem.Flags));

      if (this.hasClasses && this.classesStr) {
        generalSettings.PlanSettings.Classes =
          "[" +
          this.classesStr
            .split(",")
            .map((o) => o.trim())
            .filter((o) => o !== "")
            .map((o) => '"' + o + '"')
            .join(",") +
          "]";
        this.classesArray = JSON.parse(generalSettings.PlanSettings.Classes);
      } else {
        delete generalSettings.PlanSettings.Classes;
        this.classesArray = [];
      }
      if (this.hasOccupations && this.occupationsStr) {
        generalSettings.Occupations =
          "[" +
          this.occupationsStr
            .split(",")
            .map((o) => o.trim())
            .filter((o) => o !== "")
            .map((o) => '"' + o + '"')
            .join(",") +
          "]";
      } else {
        delete generalSettings.Occupations;
      }

      let billingImportFields = JSON.parse(
        JSON.stringify(this.selectedItem.BillingImportFields)
      );

      if (!generalSettings.PlanSettings.HasBillingImport) {
        billingImportFields = [];
      }

      let billingTerm;
      let contributionCategories;
      if (generalSettings.PlanSettings.HasBilling) {
        if (this.selectedItem.BillingTerm) {
          billingTerm = JSON.parse(
            JSON.stringify(this.selectedItem.BillingTerm)
          );
        }
        if (billingTerm === null || billingTerm === undefined) {
          billingTerm = [];
        }
        contributionCategories = JSON.parse(
          JSON.stringify(this.selectedItem.ContributionCategories)
        );
        if (
          contributionCategories === null ||
          contributionCategories === undefined
        ) {
          contributionCategories = [];
        }
      }
      let configurationParameters = JSON.parse(
        JSON.stringify(this.selectedItem.ConfigurationParameters)
      );
      for (let coverageParameter of configurationParameters) {
        // coverageParameter.ConfigurationParameter.Name = coverageParameter.ConfigurationParameter.Translations.filter(
        //   (o) => o.LanguageCode === this.language.language
        // )[0].Name;
        // coverageParameter.ConfigurationParameter.Description =
        //   coverageParameter.ConfigurationParameter.Name;
        // coverageParameter.ConfigurationParameter.SystemName = this.convertToCamelCase(
        //   coverageParameter.ConfigurationParameter.Name
        // );
        // coverageParameter.ConfigurationParameterValue.SystemType =
        //   coverageParameter.ConfigurationParameter.Type;
        if (
          coverageParameter.ConfigurationParameter.UsedInFormulaType.indexOf("Plan") > -1 ||
          coverageParameter.ConfigurationParameter.CalculationEntity ===
            "EmployerContributions" ||
          coverageParameter.ConfigurationParameter.CalculationEntity ===
            "Contributions" ||
          (coverageParameter.ConfigurationParameter.UsedInFormulaType ===
            "OperatingFee" &&
            generalSettings.PlanSettings.OperatingFeesPerTerm)
        ) {
          coverageParameter.ConfigurationParameter.PlanIdentityId =
            this.planIdentityId;
          coverageParameter.ConfigurationParameter.CoverageIdentityId = null;
          coverageParameter.ConfigurationParameter.CoverageIdentity = null;
          coverageParameter.ConfigurationParameter.IsGlobal = true;
        } else if (coverageParameter.ConfigurationParameter.UsedInFormulaType !==
        "AdminFee") {
          coverageParameter.ConfigurationParameter.PlanIdentityId = null;
          coverageParameter.ConfigurationParameter.IsGlobal = false;
        }

        // if (coverageParameter.ConfigurationParameter.Type === "Percentage")
        //   coverageParameter.ConfigurationParameterValue.Value = (
        //     coverageParameter.ConfigurationParameterValue.Value / 100
        //   ).toFixed(4);

        coverageParameter.ConfigurationParameter.EffectiveDate =
          generalSettings.PlanSettings.EffectiveDate;
        coverageParameter.ConfigurationParameterValue.EffectiveDate =
          generalSettings.PlanSettings.EffectiveDate;

        // if (coverageParameter.ConfigurationParameterValue.FundedPercentage !== null && coverageParameter.ConfigurationParameterValue.FundedPercentage !==undefined)
        // coverageParameter.ConfigurationParameterValue.FundedPercentage = (
        //   coverageParameter.ConfigurationParameterValue.FundedPercentage / 100
        // ).toFixed(4);

        if (coverageParameter.ConfigurationParameter.CoverageStatus!==null && coverageParameter.ConfigurationParameter.CoverageStatus!==undefined) {
          coverageParameter.ConfigurationParameter.CoverageStatusId = coverageParameter.ConfigurationParameter.CoverageStatus.Id;
          delete coverageParameter.ConfigurationParameter.CoverageStatus;
        }
      }

      let candidateHourImportMemberIdentifiers = JSON.parse(
        JSON.stringify(
          this.selectedItem.HoursSetup.CandidateHourImportMemberIdentifiers
        )
      );

      if (this.planType === "HW") {
        
        let planInsuranceCarriers = JSON.parse(
          JSON.stringify(this.selectedItem.PlanInsuranceCarriers)
        );

        let contacts = JSON.parse(JSON.stringify(this.selectedItem.Contacts));
        let calculationFormulas = JSON.parse(
          JSON.stringify(this.selectedItem.CalculationFormulas)
        );

        let reportConfiguration = JSON.parse(
          JSON.stringify(this.selectedItem.ReportConfiguration)
        );
        let demographicFields = JSON.parse(
          JSON.stringify(this.selectedItem.DemographicFields)
        );

        let eligibility;
        if (this.selectedItem.Eligibility) {
          eligibility = JSON.parse(
            JSON.stringify(this.selectedItem.Eligibility)
          );
        }

        if (!generalSettings.PlanSettings.HasAdminFees) {
          generalSettings.PlanSettings.AdminFeesPerTerm = false;
        }

        if (!generalSettings.PlanSettings.HasOperatingFees) {
          delete generalSettings.PlanSettings.OperatingFeesAccountName;
          generalSettings.PlanSettings.OperatingFeesPerTerm = false;
        }

        if (!generalSettings.PlanSettings.HasStores) {
          generalSettings.PlanSettings.ReportsPerStore = false;
        }

        if (!generalSettings.PlanSettings.HasPremiums) {
          planInsuranceCarriers = [];
        }
        if (!generalSettings.PlanSettings.HasDemographics) {
          demographicFields = [];
        }

        for (let planInsuranceCarrier of planInsuranceCarriers) {
          planInsuranceCarrier.PlanIdentityId = this.planIdentityId;
          if (
            planInsuranceCarrier.Address &&
            Object.keys(planInsuranceCarrier.Address).length === 0
          ) {
            planInsuranceCarrier.Address = null;
          }
          if (planInsuranceCarrier.Address) {
            if (planInsuranceCarrier.Address.Province) {
              planInsuranceCarrier.Address.ProvinceId =
                planInsuranceCarrier.Address.Province.Id;
              delete planInsuranceCarrier.Address.Province;
            }
            //  planInsuranceCarrier.Address.PostalCode = this.unmask(planInsuranceCarrier.Address.PostalCode, this.postalCodeMask);
          }

          // if (planInsuranceCarrier.PhoneNumber!== null && planInsuranceCarrier.PhoneNumber !== undefined) {
          //   planInsuranceCarrier.PhoneNumber = this.unmask(planInsuranceCarrier.PhoneNumber, this.telephoneMask);
          // }
          // if (planInsuranceCarrier.Fax!== null && planInsuranceCarrier.Fax !== undefined) {
          //     planInsuranceCarrier.Fax = this.unmask(planInsuranceCarrier.Fax, this.telephoneMask);
          //   }
          if (planInsuranceCarrier.Contacts) {
            for (let contact of planInsuranceCarrier.Contacts) {
              contact.PlanIdentityId = this.planIdentityId;
              contact.StatusId = this.activeStatus;
              // if (contact.Title !== null && contact.Title !== undefined) {
              //   contact.TitleId = contact.Title.Id;
              //   delete contact.Title;
              // }
              if (
                contact.PhoneNumber !== null &&
                contact.PhoneNumber !== undefined
              ) {
                contact.PhoneNumber = this.unmask(
                  contact.PhoneNumber,
                  this.telephoneMask
                );
              }
              if (contact.Fax !== null && contact.Fax !== undefined) {
                contact.Fax = this.unmask(contact.Fax, this.telephoneMask);
              }
            }
          }

          planInsuranceCarrier.Policy.StatusId = this.activeStatus;
          planInsuranceCarrier.Policy.EffectiveDate =
            generalSettings.PlanSettings.EffectiveDate;
        }

        for (let contact of contacts) {
          // delete contact.Status;
          contact.StatusId = this.activeStatus;
          contact.IsInHouse = true;
          contact.PlanIdentityId = this.planIdentityId;
          // if (contact.Title !== null && contact.Title !== undefined) {
          //   contact.TitleId = contact.Title.Id;
          //   delete contact.Title;
          // }
          if (
            contact.PhoneNumber !== null &&
            contact.PhoneNumber !== undefined
          ) {
            contact.PhoneNumber = this.unmask(
              contact.PhoneNumber,
              this.telephoneMask
            );
          }
          if (contact.Fax !== null && contact.Fax !== undefined) {
            contact.Fax = this.unmask(contact.Fax, this.telephoneMask);
          }
        }

        for (let formula of calculationFormulas) {
          formula.EffectiveDate = generalSettings.PlanSettings.EffectiveDate;
        }
        let selfPaymentSettings = null;
        if (generalSettings.IncludeSelfPayments) {
          selfPaymentSettings = JSON.parse(
              JSON.stringify(this.selectedItem.SelfPaymentSettings)
            );
            for (let s of selfPaymentSettings) {
              s.EffectiveDate = generalSettings.PlanSettings.EffectiveDate;
            } 
        }
        let eligibilityHourBankSettings = null;
        if (generalSettings.HasEligibility || generalSettings.HasEligibilityBank) {
          // if (eligibility===null || undefined) {
          //   eligibility = {};
          // }
          if (generalSettings.HasEligibility) {
            if (eligibility.EligibilityPeriodRules) {
              eligibility.EligibilityPeriodRules =
                eligibility.EligibilityPeriodRules.map((o) => {
                  delete o.AppliesTo;
                  delete o.Condition;
                  delete o.CheckPeriod;
                  if (o.Identifier === null || o.Identifier === undefined) {
                    o.Identifier = Math.random().toString();
                  }
                  return o;
                });
            }
            if (eligibility.CoverageCommencementRules) {
              eligibility.CoverageCommencementRules =
                eligibility.CoverageCommencementRules.map((o) => {
                  for (let c of o.Conditions) {
                    delete c.LogicalExpression;
                  }
                  o.EffectiveDate = generalSettings.PlanSettings.EffectiveDate;
                  if (o.MemberGroupIdentity) {
                    for (let c of o.MemberGroupIdentity.CoverageIdentities) {
                      c.Current.EffectiveDate =
                        generalSettings.PlanSettings.EffectiveDate;
                    }
                  }
                  if (o.Identifier === null || o.Identifier === undefined) {
                    o.Identifier = Math.random().toString();
                  }
                  return o;
                });
            }
            if (eligibility.MemberCoverageEligibilityRules) {
              eligibility.MemberCoverageEligibilityRules =
                eligibility.MemberCoverageEligibilityRules.map((o) => {
                  for (let c of o.Conditions) {
                    delete c.LogicalExpression;
                  }
                  o.EffectiveDate = generalSettings.PlanSettings.EffectiveDate;
                  console.log(o);
                  return o;
                });
          }
          } else {
            eligibility.EligibilityPeriodRules = [];
            eligibility.CoverageCommencementRules = [];
            eligibility.MemberCoverageEligibilityRules = [];
          }
          if (generalSettings.HasEligibilityBank) {
            eligibilityHourBankSettings = JSON.parse(
              JSON.stringify(this.selectedItem.EligibilityHourBankSettings)
            );
            for (let eligibilityHourBankSetting of eligibilityHourBankSettings) {
              eligibilityHourBankSetting.EffectiveDate = generalSettings.PlanSettings.EffectiveDate;
            }
          }

          if (eligibility.BenefitRules) {
            eligibility.BenefitRules = eligibility.BenefitRules.map((o) => {
              // o.IdentityId = o.Coverage.IdentityId;
              // delete o.Coverage;
              if (o.Classes && !Array.isArray(o.Classes)) {
                o.Classes = JSON.parse(o.Classes);
              }
              if (o.Classes && o.Classes.length > 0) {
                o.Classes =
                  "[" + o.Classes.map((o) => `"${o}"`).join(",") + "]";
              }
              // if (o.CoverageStatuses && o.CoverageStatuses.length > 0) {
              //   o.CoverageStatuses = o.CoverageStatuses.map((c) => {
              //     return {
              //       Id: c.Id,
              //     };
              //   });
              // }
              o.EffectiveDate = generalSettings.PlanSettings.EffectiveDate;
              if (o.Identifier === null || o.Identifier === undefined) {
                o.Identifier = Math.random().toString();
              }
              if (o.Coverage && o.Coverage.Employers) {
                for (let employer of o.Coverage.Employers) {
                  if (employer.Classes && !Array.isArray(employer.Classes)) {
                    employer.Classes = JSON.parse(employer.Classes);
                  }
                  if (employer.Classes && employer.Classes.length > 0) {
                    employer.Classes =
                      "[" + employer.Classes.map((o) => `"${o}"`).join(",") + "]";
                  }
                }
              }
              return o;
            });
          }
          if (
            eligibility.MemberEligibility !== null &&
            eligibility.MemberEligibility !== undefined
          ) {
            eligibility.MemberEligibility.IdentityId = this.planIdentityId;
            // delete eligibility.MemberEligibility.Identity;

            eligibility.MemberEligibility.EffectiveDate =
              generalSettings.PlanSettings.EffectiveDate;
          }
          
          if (eligibility.ActivityStatusRules) {
            for (let rule of eligibility.ActivityStatusRules) {
              rule.ActivityStatus.EffectiveDate =
                generalSettings.PlanSettings.EffectiveDate;
              if (rule.Identifier === null || rule.Identifier === undefined) {
                rule.Identifier = Math.random().toString();
              }
            }
          }
        } else {
          eligibility = null;
        }

        reportConfiguration.ReportConfiguration.GroupByClass =
          this.defaultDataGrouping == "Classes";
        if (
          reportConfiguration.ReportConfiguration.ReportEarningFrequency &&
          reportConfiguration.ReportConfiguration.ReportEarningFrequency.Name
        ) {
          reportConfiguration.ReportConfiguration.ReportEarningFrequency =
            reportConfiguration.ReportConfiguration.ReportEarningFrequency.Name;
        }
        if (reportConfiguration.InheritedBrokerAddress) {
          reportConfiguration.BrokerCity = this.organization.City;
          reportConfiguration.BrokerPostalCode = this.organization.PostalCode;
          reportConfiguration.BrokerProvince = this.organization.Province.Name;
          reportConfiguration.BrokerStreetName = this.organization.StreetName;
          reportConfiguration.BrokerStreetNumber =
            this.organization.StreetNumber;
          reportConfiguration.BrokerSuiteNumber = this.organization.SuiteNumber;
          reportConfiguration.BrokerLogo = this.organization.BrokerLogo;
        } else {
          console.log(this.reportConfigurationAddress);
          reportConfiguration.BrokerCity =
            this.reportConfigurationAddress.Address.City;
          reportConfiguration.BrokerPostalCode =
            this.reportConfigurationAddress.Address.PostalCode;
          // reportConfiguration.BrokerPostalCode = this.unmask(this.reportConfigurationAddress.Address.PostalCode, this.postalCodeMask);
          reportConfiguration.BrokerProvince =
            this.reportConfigurationAddress.Address.Province.Name;
          reportConfiguration.BrokerStreetName =
            this.reportConfigurationAddress.Address.StreetName;
          reportConfiguration.BrokerStreetNumber =
            this.reportConfigurationAddress.Address.StreetNumber;
          reportConfiguration.BrokerSuiteNumber =
            this.reportConfigurationAddress.Address.SuiteNumber;
        }
        reportConfiguration.Id = this.planIdentityId;
        reportConfiguration.UniqueIdentifier = generalSettings.UniqueIdentifier;
        if (generalSettings.PlanSettings) {
          reportConfiguration.Name = generalSettings.PlanSettings.Name;
          reportConfiguration.Translations =
            generalSettings.PlanSettings.Translations.map((o) => {
              return {
                Id: o.Id,
                LanguageCode: o.LanguageCode,
                Name: o.Name,
                RefId: this.planIdentityId,
              };
            });
          reportConfiguration.ReportConfiguration.IncorporateAdminFees =
            !this.selectedItem.GeneralSettings.PlanSettings.AdminFeesPerTerm;
          reportConfiguration.ReportConfiguration.IncorporateOperatingFees =
            !this.selectedItem.GeneralSettings.PlanSettings
              .OperatingFeesPerTerm;
          reportConfiguration.OperatingFeesAccountName =
            generalSettings.PlanSettings.OperatingFeesAccountName;
        }

        for (const coverageGroup of this.coverageGroups) {
          for (const coverage of coverageGroup.Coverage) {
            for (let cov of coverages) {
              if (cov.Identifier === coverage.Identifier) {
                cov.CoverageGroup = coverageGroup.Name;
              }
            }
          }
        }
        for (let cov of coverages) {
          let found = false;
          for (const coverageGroup of this.coverageGroups) {
            if (
              coverageGroup.Coverage.filter(
                (o) => o.Identifier === cov.Identifier
              ).length > 0
            ) {
              found = true;
              break;
            }
          }
          if (!found) {
            cov.CoverageGroup = null;
          }
        }

        for (let field of demographicFields) {
          field.IsOptional = false;
        }

        for (let field of candidateHourImportMemberIdentifiers) {
          field.IsOptional = true;
        }

        if (generalSettings.PlanSettings.HasBilling) {
          for (let term of billingTerm) {
            // delete term.EffectiveDate;
            if (term.IsCustom === null || term.IsCustom === undefined) {
              term.IsCustom = false;
            }
          }
        }

        if (generalSettings.Province) {
          generalSettings.ProvinceId = generalSettings.Province.Id;
        }

        return {
          GeneralSettings: generalSettings,
          PlanInsuranceCarriers: planInsuranceCarriers,
          TrustFund: trustFund,
          Employers: employers,
          Flags: flags,
          MemberDataFields: memberDataFields,
          Contacts: contacts,
          Coverages: coverages,
          ConfigurationParameters: configurationParameters,
          CalculationFormulas: calculationFormulas,
          MemberGroups: memberGroups,
          ReportConfiguration: reportConfiguration,
          DemographicFields: demographicFields,
          BillingImportFields: billingImportFields,
          Eligibility: eligibility,
          BillingTerm: billingTerm,
          ContributionCategories: contributionCategories,
          HoursSetup: {
            IncludeContributionAmount:
              this.selectedItem.HoursSetup.IncludeContributionAmount,
            PrimaryHourImportMemberIdentifier:
              this.selectedItem.HoursSetup.PrimaryHourImportMemberIdentifier,
            CandidateHourImportMemberIdentifiers:
              candidateHourImportMemberIdentifiers,
          },
          EligibilityHourBankSettings: eligibilityHourBankSettings,
          SelfPaymentSettings: selfPaymentSettings
        };
      } else if (this.planType === "Pension") {
        const unions = JSON.parse(JSON.stringify(this.selectedItem.Unions));
        for (const union of unions) {
          for (let local of union.Locals) {
            local.EffectiveDate = generalSettings.PlanSettings.EffectiveDate;
            if (local.Address) {
              if (local.Address.Province) {
                local.Address.ProvinceId = local.Address.Province.Id;
                delete local.Address.Province;
              }
            }
          }
        }
        return {
          GeneralSettings: generalSettings,
          Unions: unions,
          Employers: employers,
          TrustFund: trustFund,
          MemberDataFields: memberDataFields,
          Coverages: coverages,
          MemberGroups: memberGroups,
          Flags: flags,
          BillingImportFields: billingImportFields,
          BillingTerm: billingTerm,
          ContributionCategories: contributionCategories,
          ConfigurationParameters: configurationParameters,
          HoursSetup: {
            IncludeContributionAmount:
              this.selectedItem.HoursSetup.IncludeContributionAmount,
            PrimaryHourImportMemberIdentifier:
              this.selectedItem.HoursSetup.PrimaryHourImportMemberIdentifier,
            CandidateHourImportMemberIdentifiers:
              candidateHourImportMemberIdentifiers,
          },
        };
      }
      return {
        GeneralSettings: generalSettings,
        employers: employers,
      };
    },
    async save() {
      this.loadingPlan = true;
      const payload = this.fixPayloadForPost();
      try {
        let id = (
          await this.saveDraft({
            planIdentityId: this.draftId,
            brokerId: this.organization.Id,
            payload: payload,
          })
        ).data;

        const location = window.location.href;
        const newLocation = location.replace(this.draftId, id);
        window.history.pushState({ path: newLocation }, "", newLocation);
        this.draftId = id;
      } catch (error) {
        this.error = error;
      } finally {
        this.loadingPlan = false;
        this.isChanged = false;
        this.isValid = false;
      }
    },
    close() {
      if (!this.isChanged) {
        this.exitWithoutWarning = true;
      }
      this.$router.push({
        name: "plans",
        params: { broker: this.$route.params.broker },
      });
    },
    convertToCamelCase(input) {
      return this.toCamelCase(this.toWords(input));
    },
    toWords(input) {
      var regex =
        /[A-Z\xC0-\xD6\xD8-\xDE]?[a-z\xDF-\xF6\xF8-\xFF]+|[A-Z\xC0-\xD6\xD8-\xDE]+(?![a-z\xDF-\xF6\xF8-\xFF])|\d+/g;

      return input.match(regex);
    },
    toCamelCase(inputArray) {
      let result = "";

      for (let i = 0, len = inputArray.length; i < len; i++) {
        let currentStr = inputArray[i];

        let tempStr = currentStr.toLowerCase();

        if (i != 0) {
          // convert first letter to upper case (the word is in lowercase)
          tempStr = tempStr.substr(0, 1).toUpperCase() + tempStr.substr(1);
        }

        result += tempStr;
      }

      return result;
    },
    async tryValidate() {
      this.validated = true;
      this.loadingPlan = true;
      this.validationErrors = [];
      this.panelsWithErrors = [];
      try {
        let errors = (
          await this.validateDraft({
            planIdentityId: this.draftId,
          })
        ).data;

        if (errors && errors.length > 0) {
          this.validationErrors = errors.map((o) => o.Errors).flat();
          this.panelsWithErrors = [...new Set(errors.map((o) => o.ErrorName))];
          this.isValid = false;
        } else {
          this.isValid = true;
        }
      } catch (error) {
        this.error = error;
      } finally {
        this.loadingPlan = false;
        this.$nextTick(() => {
          this.$refs.creationWizard.scrollToValidationErrors();
        });
      }
    },
    unmask(v, mask) {
      if (v) {
        return masker(v, mask, false, tokens);
      }
      return v;
    },
    async loadUniqueIdentifiers() {
      try {
        this.uniqueIdentifiers = (
          await this.getPlanUniqueIdentifiersById({
            draftId: this.draftId,
          })
        ).data;
      } catch (error) {
        this.error = error;
      }
    },
  },
};
</script>
